import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';
/* Dialogs */
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import AddToList from '../common/AddToList';
import AddAccessoriesDialog from '../../dialogs/addAccessoriesDialog';
import * as messageConstants from '../../common/messageConstants';
import ChangeZipCode from '../common/changeZipCode';
import { routes } from '../../../redux/api/routes';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import ToolTipOverlayDialog from '../../dialogs/toolTipOverlayDialog';
import DatePicker from 'react-datepicker';
import { DATE_TIME_FORMAT } from '../../common/messageConstants';
const { productGEUrl } = routes;

/* Actions */
import {
	addToList,
	saveToList,
	addToCart,
	saveToCart,
	checkServicesPricesForCartPage,
	getPriceOrder,
	checkForPrices,
	getPIMItemInfo,
	saveCreateOrderPayload,
	getOrderList,
	saveBookedOrders,
	getBillingReferences,
	saveBillingReferences,
	updatePricesToCart,
	getShippingMethod,
	resetAvailabilityToCart,
	resetErrorLog,
	resetServicesPricesToCart,
	resetPricesToCart,
	getOrderableServices,
	saveOrderableServices,
	checkServicePrices,
	saveCreateOrderPayloadBackup,
	saveAvailabilityToCart,
	removeAvailabilityFromCart,
	getDeliveryCalendar,
} from '../../../redux/actions';

/*
	common utility function
*/
import {
	processPricingResponse
} from '../../../redux/util';

class Cart extends Component {

	constructor(props) {
		super(props);
		this.state = {
			backOrderCallCompleted: false,
			bulkOrderHoldCallCompleted: false,
			callReveiveProps: true,
			showAddAccessories: false,
			showToolTipOverlayDialog: false,
			errorMessage: 'There are currently no products in your Cart.',
			showErrorMessage: false,
			errorOccured: "",

			// using below flags to maintain status of parallel calls before redirecting to create order page
			isPricingCallCompleted: false,
			isPricingChanged: false,
			isPimCallCompleted: false,
			isShippingMethodCompleted: false,
			orderDetailsCallCompleted: false,
			pricingData: null,
			pimData: null,

			last30DaysOrders: null,
			last60DaysOrders: null,
			isLast30DaysOrdersCompleted: false,
			isLast60DaysOrdersCompleted: false,
			isBillingPreferencesCallCompleted: false,
			isGetAddressCallCompleted: false,

			isCartProductPriceCallCompleted: false,
			isCartServicePriceCallCompleted: false,
			date: null,
			isCartPimDataCallCompleted: false,
			isCartGetOrgAttributesCompleted: false,
			punchoutOrerableServies : {
				zipCode : "",
				agentid : "",
				loctype: "",
				inventoryLoc: "",
				sdsApZone: "",
				stateVal: "",
				agreementNumber : "",
				accountNumber : "",
				country:"",
				isShowInstallServiceForPunchout : false,
			},
			cartItem : {},
			availableServices: false,
			selectedSKU: '',
			selectedSKUIndex: '',
			itemLevelDisableUncrateDropdown: false,
			showAddServicesOverlayDialog: false,
			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			availabilityData:[],
			changedSABackup: [],
			date:null,
			hasSdsLoc: false,
		};
		this.callBackBeforeRedirectingToCreateOrder = this.callBackBeforeRedirectingToCreateOrder.bind(this);
		this.callBackAfterAllCallCompleted = this.callBackAfterAllCallCompleted.bind(this);
		this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
		this.getShippingAddressState = this.getShippingAddressState.bind(this);
		this.validateFP = this.validateFP.bind(this);
		this.validateFDD = this.validateFDD.bind(this);
		this.fireCartViewTag = this.fireCartViewTag.bind(this);
		this.handleContinueCreateOrder = this.handleContinueCreateOrder.bind(this);
		this.manageAvailableServices = this.manageAvailableServices.bind(this);
		this.resetSelectedSKU = this.resetSelectedSKU.bind(this);
		this.updateCartWithLatestUpdatedItems = this.updateCartWithLatestUpdatedItems.bind(this);
		this.updateServicePricing = this.updateServicePricing.bind(this);
		this.removeFromDialogCart = this.removeFromDialogCart.bind(this);
		this.checkAndExecuteIfShippingDetailsAvailable = this.checkAndExecuteIfShippingDetailsAvailable.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentWillMount() {
		this.props.resetErrorLog();
	}

	handleChange(date) {
	  	const self = this;		
	  	self.setState({
		  date: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,	
	  	});
		localStorage.setItem("sdsDate", moment(date).format("YYYY-MM-DD"))
	}
	componentWillReceiveProps(nextProps) {
		const self = this;
		if(
			(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) ||
			(self.props.state.user.selectedADC && self.props.state.user.selectedADC !== nextProps.state.user.selectedADC) ||
			(self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode)
		) {
			self.props.resetAvailabilityToCart();
			setTimeout(() => {
				self.setState({
					onlyAvailabilityCall: true,
					isCartGetOrgAttributesCompleted: false,
					isCartPimDataCallCompleted: false,
					isCartProductPriceCallCompleted: false,
					isCartServicePriceCallCompleted: false
				}, () => {
					self.checkAndExecuteIfShippingDetailsAvailable();
				})
			}, 40);
		}
		// This block will only execute if user is refreshing cart page
		const cartItems = self.props.state.cart && self.props.state.cart.cart && self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems;
		// once back orders are loaded need to check if there is any item which is having orderNumber or not
        if(self.state.callReveiveProps && cartItems && cartItems.find(itm => itm.orderNumber) && nextProps.state.order.backOrders && nextProps.state.order.backOrders !== self.props.state.order.backOrders) {
			self.setState({
				backOrderCallCompleted: true,
				backOrders: nextProps.state.order.backOrders.responseObject || []
			}, () => {
				self.callBackAfterCallsCompletedNormal();
			});
        }
		if(self.state.callReveiveProps && cartItems && cartItems.find(itm => itm.orderNumber) && nextProps.state.order.bulkOrdersHold && nextProps.state.order.bulkOrdersHold !== self.props.state.order.bulkOrdersHold) {
			self.setState({
				bulkOrderHoldCallCompleted: true,
				bulkOrders: nextProps.state.order.bulkOrdersHold.responseObject || []
			}, () => {
				self.callBackAfterCallsCompletedNormal();
			});
        }
	}

	callBackAfterCallsCompletedNormal() {
		const self = this;
		const { backOrderCallCompleted, bulkOrderHoldCallCompleted, backOrders, bulkOrders } = self.state;
		if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
			self.verifyBackOrders(backOrders.concat(bulkOrders));
		}
	}

	checkAndExecuteIfShippingDetailsAvailable() {
		const self = this;
		const myInt = setInterval(() => {
			const zipCode = self.props.customZipCode;
			zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					clearInterval(myInt);
					self.checkAvailabilityAndAll();
				}
			});
		}, 150);
	}

	verifyBackOrders(backOrders, callback) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		// if any item is having order number check below criteria from those items which is having orderNumber
		// 1. if any items whose backOrders quantity is 0 OR no item details available then delete that item from cart
		// 2. if any item is having quantity > backOrders quantity then update cart with backOrders quantity for that particular item
		// 3. in other scenario no change in cart
		const cartItems = [];
		let anyChangeRequiredInCart = false;
		self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems.forEach((item) => {
			if(item.orderNumber) {
				const backOrder = backOrders.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
				// Now onwards we will have orderLineId in cart items so we will use that to find item details by orderLineId
				let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => {
					return item.orderLineId && item.orderLineId === itm.orderLineId && itm.lineStatus.toLowerCase() !== 'cancelled'
				});
				// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
				if(itemDetails) {
					// This can be used once user click on create order as we r removing dependencies of order details parallel calls
					item.orderLineNumber = `${itemDetails.lineNum}.${itemDetails.shipmentNum}`
					// 1. if any items whose backOrders quantity is 0 then delete that item from cart
					// So we will only set flag but not add that particular item in cartItems for payload
					if(itemDetails.orderedQty === 0) {
						anyChangeRequiredInCart = true;
					} else if(item.quantity > itemDetails.orderedQty) {
						anyChangeRequiredInCart = true;
						cartItems.push({
							...item,
							quantity: itemDetails.orderedQty
						});
					} else {
						cartItems.push(item);
					}
				}
				// If no item details available then we need to ignore current item so that it will get removed from cart
				else {
					anyChangeRequiredInCart = true;
				}
			} else {
				cartItems.push(item);
			}
		});
		if(anyChangeRequiredInCart) {
			let payload = {
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems
			};
			this.props.addToCart(payload, response => {
				if (response.status && response.responseObject) {
					self.props.saveToCart(response);
					callback && callback();
				} else {
					browserHistory.push('/error');
				}
			});
		} else {
			callback && callback();
		}
	}

	getShippingAddressZipCode() {
		const self = this;
		// const { createOrderPayloadBackup } = self.props.state.order;
		// if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params && createOrderPayloadBackup.createOrderForm.params.shippingAddress && createOrderPayloadBackup.createOrderForm.params.shippingAddress.zip) {
		// 	return createOrderPayloadBackup.createOrderForm.params.shippingAddress.zip.split("-")[0];
		// }
		return self.props.getZipCode();
	}

	componentDidUpdate(prevProps) {
		const isPunchOutAccess = this.props.isPunchOutAccess();
		if (prevProps.state.cart.availability !== this.props.state.cart.availability) {
			this.fetchDeliveryCalendar();
		}}

	fetchDeliveryCalendar = () => {
		const cartState = this.props.state.cart;
		const userState = this.props.state.user;

		// if (!cartState || !cartState.availability || !cartState.availability.length) {
		// 	return;
		// }
		const availability = cartState.availability;
		const etaDates = availability.filter(function (item) {
			return item && item.etaDate;
			}).map(function (item) {
			return moment(item.etaDate, "MM/DD/YYYY");
			});
		//if (!etaDates.length) {	return;	}
		const maxMoment = moment.max(etaDates);
		//if (!maxMoment || !maxMoment.isValid()) {return;}
		const startDate = maxMoment.format("YYYY-MM-DD");
		// if (!userState || !userState.shippingAddressDetailsListWithZipCode || !userState.shippingAddressDetailsListWithZipCode.length) {
		// 	return;
		// }
		//const address = userState.shippingAddressDetailsListWithZipCode[0];
		//if (!address || !address.zipCode || !address.state) { return;}
		const addressList = userState.shippingAddressDetailsListWithZipCode;
		const address = addressList.find(
			entry => entry.zipCode === this.props.customZipCode
		) || addressList[addressList.length - 1];
		// if (!address || !address.zipCode || !address.state) { return; }
		// if (!userState.selectedAccount || !userState.selectedAccount.ACCOUNTNUMBER) {return;}
		const payload = {
			accountNo: userState.selectedAccount.ACCOUNTNUMBER,
			zipcode: this.props.customZipCode,
			state: address.state,
			mode: "SDS",
			startDate: startDate,
			noOfDays: 180
		};

		this.props.getDeliveryCalendar(	payload, "requestType=getSdsCalendar", true, function (response) {
			var dates = [];
			if (response &&	response.responseObject &&	response.responseObject.calendar_dates && response.responseObject.calendar_dates.length) {
				dates = response.responseObject.calendar_dates;
			}
			this.setState({
				sdsDeliveryCalendar: { dates: dates }
			});
			}.bind(this)
		);
		}

	getShippingAddressState() {
		const self = this;
		const { createOrderPayloadBackup } = self.props.state.order;
		if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params && createOrderPayloadBackup.createOrderForm.params.shippingAddress && createOrderPayloadBackup.createOrderForm.params.shippingAddress.state) {
			return createOrderPayloadBackup.createOrderForm.params.shippingAddress.state;
		}
		return null;
	}

	componentDidMount() {
		const { createOrderPayloadBackup } = this.props.state.order;
		if (createOrderPayloadBackup) {
			const updatedCreateOrderPayloadBackup = {
				...createOrderPayloadBackup,
				date: null,
				date2: null,
				date3: null,
			}
			if (updatedCreateOrderPayloadBackup.createOrderForm && updatedCreateOrderPayloadBackup.createOrderForm.params) {
				updatedCreateOrderPayloadBackup.createOrderForm.params = {
					...updatedCreateOrderPayloadBackup.createOrderForm.params,
					requestedDeliveryDate: '',
					requestedDeliveryDate2: '',
					requestedDeliveryDate3: '',
					requestedDeliveryDateError: '',
					requestedDeliveryDate2Error: '',
					requestedDeliveryDate3Error: '',
				}
			}
			this.props.saveCreateOrderPayloadBackup(updatedCreateOrderPayloadBackup);
		}

		const { defaultSelectedADC, selectedAccount, selectedADC, selectedAddress, userDetails, shippingAddressDetailsListWithZipCode } = this.props.state.user;
		const cartItems = this.props.state && this.props.state.cart && this.props.state.cart.cart && this.props.state.cart.cart.responseObject && this.props.state.cart.cart.responseObject.cartItems;
		const startDate = moment.max(cartItems.filter(item => item.shipDate).map(item => moment(item.shipDate, "MM/DD/YYYY"))).format("YYYY-MM-DD");
		// const isPunchOutAccess = this.props.isPunchOutAccess();
		// if(isPunchOutAccess && shippingAddressDetailsListWithZipCode && shippingAddressDetailsListWithZipCode[0] && shippingAddressDetailsListWithZipCode[0].details.some(d => d.loctype === "sds_loc")){
		// 	this.setState({
		// 		hasSdsLoc: true
		// 	})
		// }else{
		// 	localStorage.setItem("sdsDate", moment().add(5, "days").format("YYYY-MM-DD"));
		// }
		const payload = {
						accountNo: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
						zipcode:shippingAddressDetailsListWithZipCode &&  shippingAddressDetailsListWithZipCode.length && shippingAddressDetailsListWithZipCode[0] && shippingAddressDetailsListWithZipCode[0].zipCode,
						state: shippingAddressDetailsListWithZipCode && shippingAddressDetailsListWithZipCode.length && shippingAddressDetailsListWithZipCode[0] && shippingAddressDetailsListWithZipCode[0].state,
						mode:"SDS",
						startDate:"",
						startDate:startDate,
						noOfDays: 180
					};
			this.props.getDeliveryCalendar(payload, 'requestType=getSdsCalendar', true, response => {
				let dates = [];
				if (response && response.responseObject && response.responseObject.calendar_dates && response.responseObject.calendar_dates.length) {
					dates = response.responseObject.calendar_dates;
				}
				this.setState({
					sdsDeliveryCalendar : {dates}
				})
		});

		if (userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && defaultSelectedADC && defaultSelectedADC !== selectedADC) {
			this.props.setDefaultADC(JSON.parse(selectedAddress, selectedAccount.ACCOUNTNUMBER));
		} else {
		this.checkAndExecuteIfShippingDetailsAvailable();
		}
	}

	checkOrderAvailability = (shippingAddressDetails, callback) => {
		const skuList = [];
		let data = JSON.parse(this.props.state.user.selectedAddress);
		const cartItems = this.props.state.cart.cart;
		const availableBackorderItemsAvailability = [];
		cartItems.responseObject && cartItems.responseObject.cartItems && cartItems.responseObject.cartItems.length > 0 && cartItems.responseObject.cartItems.forEach((item, index) => {
			if (item.orderNumber) {
				const availabilityData = this.props.state.cart.availability && this.props.state.cart.availability.find(availabilityItem => availabilityItem.sku === item.item);
				if (availabilityData) {
					availableBackorderItemsAvailability.push(availabilityData);
				}
			}
			if ((item.itemType === 'M' || item.itemType === 'A') && !item.orderNumber) {
				skuList.push({
					itemNumber: item.item,
					identifier: index + 1,
					qty: item.quantity || 1,
					shipMethod: 'ADC Truckload',
					arrivalSetName: '',
					itemType: '',
					demandClass: this.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
					overrideFlag: 'N',
					quantityUOM: 'EA',
					agreementNumber: item.agreementNumber,
				});
			}
		});
		const payload = {
			accountNumber: this.props.getSelectedAccountNumber(),
			warehouseCode: shippingAddressDetails.agentid,
			customerSiteId: data.addressId ? data.addressId : data.SITE_USE_ID,
			requestedDeliveryDate: moment().format('MM/DD/YYYY'),
			orderSource: '',
			zipCode: this.props.customZipCode,
			state: data.STATE || "",
			country: data.COUNTRY,
			tradingPartnerId:'',
			dateType: 'SHIP',
			items: skuList,
		};
		this.props.checkAvailabilityForOrder(payload, orderAvailability => {
			if (callback) {
				callback(orderAvailability);
			} else {
				if (orderAvailability) {
					this.props.saveAvailabilityToCart({responseObject: orderAvailability.map(orderAvailabilityItem => this.props.formatOrderAvailabilityData(orderAvailabilityItem)).concat(availableBackorderItemsAvailability)});
				}
			}
		});
	}

	compareSalesAgreements = (cartItem, priceRecord) => {
		return this.props.state.user.isDpmAccount ? (priceRecord.sa_number === cartItem.agreementNumber || priceRecord.sa_number === routes.dpmData.fallbackFGSalesAgreementNumber) : priceRecord.sa_number === cartItem.agreementNumber;
	}

	checkAvailabilityAndAll() {
		const self = this, { selectedAccount, selectedPriceSource, selectedAddress: selectedAddressString } = self.props.state.user;
		const skuList = [];
		const availableBackorderItems = [];
		const servicesSkuList = [];
		let isOrderAvailabilityCallRequired = false;
		let isLegacyAvailabilityCallRequired = false;
		let isPimCallRequired = false;
		let isPricingCallRequired = false;
		let isServicePricingCallRequired = false;

		self.props.state.cart.cart && self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems && self.props.state.cart.cart.responseObject.cartItems.length && self.props.state.cart.cart.responseObject.cartItems.forEach(item => {
			if (item.itemType === 'M' || item.itemType === 'A') {
				const cartItemAvailability = this.props.state.cart.availability.find(availabilityItem => availabilityItem.sku === item.item);
				if (item.orderNumber) {
					availableBackorderItems.push({ sku: item.item, demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1] });
					if(!(cartItemAvailability && cartItemAvailability.warehouseCode===self.props.state.user.selectedADC)) {
						isLegacyAvailabilityCallRequired = true;
					}
				} else {
					skuList.push({ sku: item.item, demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1] });
					if(!(cartItemAvailability && cartItemAvailability.warehouseCode===self.props.state.user.selectedADC) || cartItemAvailability.agreementNumber !== item.agreementNumber) {
						isOrderAvailabilityCallRequired = true;
					}
				}
				const cartItemPrice = self.props.state.cart.prices && self.props.state.cart.prices.find(priceItem => priceItem.item_number === item.item && priceItem.records && (!priceItem.records.length || priceItem.records.some(priceRecord => this.compareSalesAgreements(priceRecord, item))));
				if (!cartItemPrice) {
					isPricingCallRequired = true;
				}
			} else {
				servicesSkuList.push({ sku: item.item });
				const servicePrice = this.props.state.cart.services_prices && this.props.state.cart.services_prices.find(servicePriceItem => servicePriceItem.itemNumber === item.item);
				if (!servicePrice) {
					isServicePricingCallRequired = true;
				}
			}
			let cartItemPimData = this.props.state.cart.cartPimData && this.props.state.cart.cartPimData.pimData && this.props.state.cart.cartPimData.pimData.find(pimItem => pimItem.item_number === item.item);
			if (!cartItemPimData) {
				isPimCallRequired = true;
			}
		});

		if(self.props.state.cart.availability.length === 0 || isLegacyAvailabilityCallRequired || isOrderAvailabilityCallRequired || isPimCallRequired || isPricingCallRequired || isServicePricingCallRequired || self.state.isPricingChanged) {
			if(skuList.length || availableBackorderItems.length) {
				if(!self.state.onlyAvailabilityCall && isPimCallRequired) {
					self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
						self.setState({
							isCartGetOrgAttributesCompleted: true,
						}, () => {
							self.props.getPimDataForCartItem((response) => {
								if(response.status) {
									const responseObject = response.responseObject ? response.responseObject : null;
									self.setState({
										isCartPimDataCallCompleted: true,
										cartPimData: responseObject
									}, () => {
										self.callBackAfterAllCallCompleted();
									});
								}
							})
							self.callBackAfterAllCallCompleted();
						})
					});
				} else {
					self.setState({
						isCartPimDataCallCompleted: true,
						isCartGetOrgAttributesCompleted: true,
					}, () => {
						self.callBackAfterAllCallCompleted();
					});
				}
				const zipCode = self.props.customZipCode;
				zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						if (isLegacyAvailabilityCallRequired) {
							self.props.checkAvailabilityGroupByDemandClass(availableBackorderItems, `accountNumber=${selectedAccount.ACCOUNTNUMBER}&zipCode=${zipCode}&warehouseCode=${resp.agentid}`, false, null, '', true, legacyAvailabilityResponse => {
								if (isOrderAvailabilityCallRequired || skuList.length) {
									this.checkOrderAvailability(resp, orderAvailability => {
										this.props.saveAvailabilityToCart({responseObject: orderAvailability.map(orderAvailabilityItem => this.props.formatOrderAvailabilityData(orderAvailabilityItem)).concat(legacyAvailabilityResponse.responseObject || [])});
									});
								} else {
									this.props.saveAvailabilityToCart({responseObject: legacyAvailabilityResponse.responseObject || []});
								}
							});
						} else if (isOrderAvailabilityCallRequired) {
							this.checkOrderAvailability(resp);
						}
						const isPricingAccess = self.props.isResponsibilityExists("Price");
						if (!self.state.onlyAvailabilityCall && isPricingAccess && (!self.state.isCartProductPriceCallCompleted || isPricingCallRequired || isServicePricingCallRequired)) {
							// Make pricing parallel service call
							self.props.makeParallelCallsForCartPrices(self.props.state.cart.cart.responseObject.cartItems, true, true, 'cart', null, () => {
								self.setState({
									isCartProductPriceCallCompleted: true,
								}, () => {
									self.callBackAfterAllCallCompleted();
								});
							});

							var servicesPayload = [];
							// fetch site id from SOLD_TO to address
							const soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');
							let state = 'NA';
							let whse = 'NA';
							let zone = 'NA';
							if (soldToAddresses.length > 0) {
								state = soldToAddresses[0].STATE;
							}
							const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
							self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
								if (resp) {
									whse = resp.agentid;
									zone = resp.sdsApZone;
									const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
									servicesSkuList.length > 0 && servicesSkuList.map((item, index) => {
										return servicesPayload.push({
											pricingEffectiveDate: pricingEffectiveDate,
											accountNumber,
											state: self.getShippingAddressState() || state,
											zone: zone,
											whse: whse,
											salesAgreementNumber,
											itemNumber: item.sku
										});
									});
									if(servicesPayload.length > 0) {
										self.props.checkServicesPricesForCartPage({ items: servicesPayload }, `requestType=servicesPricing`, () => {
											self.setState({
												isCartServicePriceCallCompleted: true,
											}, () => {
												self.callBackAfterAllCallCompleted();
											});
										});
									} else {
										self.setState({
											isCartServicePriceCallCompleted: true,
										}, () => {
											self.callBackAfterAllCallCompleted();
										});
									}
								}
							});
						} else {
							self.setState({
								isCartProductPriceCallCompleted: true,
								isCartServicePriceCallCompleted: true,
							}, () => {
								self.callBackAfterAllCallCompleted();
							});
						}
					}
				});
			} else {
				self.props.fireGTMTag('Cart View', {
					cartQuantity: 0,
					cartValue: 0
				})
			}
		} else {
			self.fireCartViewTag();
		}

		if(self.props.isPunchOutAccess()){
			try{
				const {AGREEMENT_NUMBER, ACCOUNT_NUMBER, SHIPPING_METHOD } = this.props.state.user.selectedPriceSource;
				let data = JSON.parse(self.props.state.user.selectedAddress);
				let zipCode = data ? data.POSTALCODE.split('-')[0] : '';
				let CustomZipCode = self.props && self.props.customZipCode || zipCode;
				let shippingAddressDetail = _.find(this.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: CustomZipCode});
				let sdsLocObject = _.find(shippingAddressDetail.details, {loctype: "sds_loc"});
				const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
				if(SHIPPING_METHOD == "000001_XXXX_S_STDEL"){
					let punchoutOrerableServies = {
						zipCode : CustomZipCode,
						agentid : sdsLocObject && sdsLocObject.agentid,
						loctype: sdsLocObject && sdsLocObject.loctype,
						inventoryLoc: sdsLocObject && sdsLocObject.inventoryLoc,
						sdsApZone: sdsLocObject && sdsLocObject.sdsApZone,
						state: data.STATE,
						country : data.COUNTRY,
						agreementNumber : salesAgreementNumber ? salesAgreementNumber: AGREEMENT_NUMBER,
						accountNumber : accountNumber ? accountNumber : ACCOUNT_NUMBER,
						isShowInstallServiceForPunchout: true
					}

					const relatedServices = [];
					let cartItems = JSON.parse(JSON.stringify(this.props.state.cart.cart.responseObject.cartItems));
					this.props.state.cart.cart.responseObject.cartItems.map(item =>{
						if(!item.itemType != "S" && item.parentItem && sdsLocObject){
							relatedServices.push({
								parentItem : item.parentItem,
								serviceId: item.item,
								price: item.unitPrice,
								serviceName: item.description,
								quantity: item.quantity,
								extendedPrice: parseFloat(item.unitPrice * item.quantity),
							});
						}
					})
					if(relatedServices && relatedServices.length > 0){
						cartItems.map(cItem => {
							if(cItem.itemType != "S"){
								let relatedItemServie = relatedServices.filter(rs => rs.parentItem == cItem.item)
								cItem.relatedServices = relatedItemServie;
							}
							return null;
						});
					}

					cartItems = cartItems.filter((itm)=>{
								if((sdsLocObject && itm.itemType=="S" || itm.itemType=="M") || (!sdsLocObject && itm.itemType=="M")){
									return true;
								}
								return false;
							})
					
					this.setState((prevState) => ({
						...prevState, 
						punchoutOrerableServies,
						cartItem : cartItems,
						sdsLocObject : sdsLocObject
					  }));
				}
			}
			catch(error){
				console.log(error);
				this.setState((prevState) => ({
					...prevState, 
					punchoutOrerableServies :{
						...this.state.punchoutOrerableServies,
						isShowInstallServiceForPunchout: false
					}
				  }));
			}
		}
	}

	showInstallService(sku,index,event ){
		event && event.preventDefault();
		const self = this;
		const {punchoutOrerableServies} = self.state;
		self.setState({
			itemLevelDisableUncrateDropdown : false,
			selectedSKU: sku,
			selectedSKUIndex: index,
		}, () => {
			const record = _.find(self.props.state.order.orderableServices, {sku: sku, zipCode: punchoutOrerableServies.zipCode});
			if(record && record.zipCode == punchoutOrerableServies.zipCode) {
				self.manageAvailableServices(self.props.state.order.orderableServices, sku, punchoutOrerableServies.zipCode);
			} else {
				self.props.getOrderableServices({
					OrderabilityRequest: {
						inventoryorg: punchoutOrerableServies.agentid,
						zipcode: punchoutOrerableServies.zipCode,
						shipmethod: "SDS Delivery",
						itemnumbers: [sku]
					}
				}, "requestType=getOrderableServices", response => {
					if(response.status) {
						const orderableServices = JSON.parse(JSON.stringify(response));
						const servicesPayload = [];
						response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
							if(item.service.length === 4 && item.service.indexOf("M") === 0) {
								servicesPayload.push({
									pricingEffectiveDate: moment().format('YYYYMMDD'),
									accountNumber:punchoutOrerableServies.accountNumber,
									state: punchoutOrerableServies.state,
									whse: punchoutOrerableServies.agentid,
									zone: punchoutOrerableServies.sdsApZone,
									salesAgreementNumber:punchoutOrerableServies.agreementNumber,
									itemNumber: item.service
								});
							}
						});
						
						self.setState((prevState) => ({
							...prevState,
							requiredPayloadForServicePricing: {
								pricingEffectiveDate: moment().format('YYYYMMDD'),
								accountNumber:punchoutOrerableServies.accountNumber,
								state: punchoutOrerableServies.state,
								whse: punchoutOrerableServies.agentid,
								zone: punchoutOrerableServies.sdsApZone,
								salesAgreementNumber:punchoutOrerableServies.agreementNumber,
								postalCode: punchoutOrerableServies.zipCode,
								country: punchoutOrerableServies.country || "US"
							}
						}), () => {
							if(servicesPayload.length > 0) {
								self.props.resetServicesPricesToCart([]);
								self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
									if(resp.status) {
										resp.responseObject = JSON.parse(resp.responseObject);
										const orderableServicesTemp = [];
										orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
											let record = _.find(resp.responseObject.items, {itemNumber: item.service});
											// record.unitPrice = 200;
											if(record && (record.unitPrice || record.unitPrice === 0)) {
												orderableServicesTemp.push({
													...item,
													servicePrice: record.unitPrice,
													serviceDescription: item.description,
												});
											}
										});
										let finalData = [];
										finalData.push({
											sku: sku,
											services: _.filter(orderableServicesTemp, {itemnumber: sku}),
											zipCode: punchoutOrerableServies.zipCode || self.getShippingAddressZipCode()
										});
										
										let existingOrderableServices = self.props.state.order.orderableServices;
										existingOrderableServices = existingOrderableServices.filter(it => it.sku !== sku);
										existingOrderableServices = existingOrderableServices.concat(finalData);
										self.props.saveOrderableServices(existingOrderableServices);
										self.manageAvailableServices(finalData, sku, punchoutOrerableServies.zipCode);
									} else {
										browserHistory.push("/error");
									}
								})
							} else {
								let finalData = [];
								finalData.push({
									sku: sku,
									services: [],
									zipCode: punchoutOrerableServies.zipCode
								})
								self.manageAvailableServices(finalData, self.state.selectedSKU, punchoutOrerableServies.zipCode);
							}
						});
					}
				});
			}
		});
	}

	resetSelectedSKU() {
		var self = this;
		setTimeout(() => {
			self.updateServicePricing()
			self.setState({
				selectedSKU: '',
				selectedSKUIndex: '',
			})
		}, 300);
	}

	handleSelectedServices(serviceData, skuList, selectedSKUIndex, uncrateInd) {
		var self = this,
			items = this.props.state.cart.cart.responseObject.cartItems,
			cartItem = JSON.parse(JSON.stringify(this.state.cartItem))
			let foundItem = items.find((itm,index) => index == selectedSKUIndex);
			foundItem = JSON.parse(JSON.stringify(cartItem.find((itm,index) => itm.item == foundItem.item)));
			
			let relatedServicesOfFoundItem = [];
			items.map((outerItem, outerIndex) => {
				if (outerIndex === selectedSKUIndex) {
					if (skuList) {
						outerItem.relatedServices = skuList;
					}
					if (outerItem.relatedServices.length === 0) {
						delete outerItem.relatedServices;
					}

					if(outerItem.relatedServices && outerItem.relatedServices.length > 0){
						relatedServicesOfFoundItem = outerItem.relatedServices.map(rs => rs.serviceId);
					}
			
					cartItem.map((innerItem) => {
						if (outerItem.item === innerItem.item) {
							innerItem.relatedServices = skuList;
							if (innerItem.relatedServices.length === 0) {
								delete innerItem.relatedServices;
							}
						}
						return null;
					});
				}
				return null;
			});
			

			if(relatedServicesOfFoundItem && relatedServicesOfFoundItem.length > 0 && foundItem.relatedServices && foundItem.relatedServices.length > 0){
				const missingItems = foundItem.relatedServices.filter(itemA => !relatedServicesOfFoundItem.some(itemB => itemA.serviceId === itemB));
				if(missingItems && missingItems.length > 0){
					missingItems = missingItems.map(mt => mt.serviceId);
					items = items.filter(item => !(item.parentItem ==foundItem.item && missingItems.includes(item.item)))
					cartItem = cartItem.filter(item => !(item.parentItem ==foundItem.item && missingItems.includes(item.item)))
				}
			}
			else if(foundItem.relatedServices && foundItem.relatedServices.length > 0){
				const missingItems = foundItem.relatedServices.map(mt => mt.serviceId);
				items = items.filter(item => !(item.parentItem ==foundItem.item && missingItems.includes(item.item)))
				cartItem = cartItem.filter(item => !(item.parentItem ==foundItem.item && missingItems.includes(item.item)))
			}
		if(foundItem.relatedServices){
			items.map((outerItem, outerIndex) => {
				if (outerIndex === selectedSKUIndex) {
					outerItem.relatedServices = outerItem.relatedServices.filter(itemA => !foundItem.relatedServices.some(itemB => itemA.serviceId === itemB.serviceId));
					if (outerItem.relatedServices && outerItem.relatedServices.length === 0) {
						delete outerItem.relatedServices;
					}
				}
			});
		}	
		this.props.state.cart.cart.responseObject.cartItems = items;	
		self.setState({
			showAddServicesOverlayDialog: false,
			cartItem : cartItem
		}, () => {
			self.updateCartWithLatestUpdatedItems();
			self.resetSelectedSKU();
		});
	}

	updateServicePricing(sdsLocObject){
		const self = this;
		const {punchoutOrerableServies} = self.state;
		const servicesSkuList = [],servicesPayload = [];
			self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems && self.props.state.cart.cart.responseObject.cartItems.length > 0 && self.props.state.cart.cart.responseObject.cartItems.forEach((item, index) => {
				if (!(item.itemType === 'M' || item.itemType === 'A')){
					servicesSkuList.push({ sku: item.item });
				}
					
				
			});
			
			servicesSkuList.length > 0 && servicesSkuList.map((item, index) => {
											return servicesPayload.push({
												pricingEffectiveDate: moment().format('YYYYMMDD'),
												accountNumber:sdsLocObject && sdsLocObject.accountNumber || punchoutOrerableServies.accountNumber,
												state: sdsLocObject && sdsLocObject.state || punchoutOrerableServies.state,
												whse: sdsLocObject && sdsLocObject.agentid || punchoutOrerableServies.agentid,
												zone: sdsLocObject && sdsLocObject.sdsApZone || punchoutOrerableServies.sdsApZone,
												salesAgreementNumber: sdsLocObject && sdsLocObject.agreementNumber || punchoutOrerableServies.agreementNumber,
												itemNumber: item.sku
											});
										});
										
										if(servicesPayload.length > 0) {
											self.props.checkServicesPricesForCartPage({ items: servicesPayload }, `requestType=servicesPricing`, () => {
												self.setState({
													isCartServicePriceCallCompleted: true,
												}, () => {
													self.callBackAfterAllCallCompleted();
												});
											});
										} else {
											self.setState({
												isCartServicePriceCallCompleted: true,
											}, () => {
												self.callBackAfterAllCallCompleted();
											});
										}
	}

	updateCartWithLatestUpdatedItems() {
		const self = this;
		const { selectedAccount, userDetails } = self.props.state.user;
		const updatedItems = [];
		let cartItem = JSON.parse(JSON.stringify(this.state.cartItem))
		let items = JSON.parse(JSON.stringify(this.props.state.cart.cart.responseObject.cartItems));
		items = _.pullAllBy(items, [{item: 'CUSTOMER MINIMUM DELIVERY'}, {item: 'LTL FREIGHT CHARGE'}, {item: 'HANDLING CHARGE'}], 'item');
		let formError = false;
		items.forEach(item => {
			if(!item.quantity) {
				formError = true;
			}
			let tempItem = {
	            itemType: item.itemType,
	            item: item.item,
	            quantity: item.quantity && item.quantity !== '0' ? item.quantity : 1,
	            itemDescription: item.itemDescription,
				agreementNumber: item.agreementNumber,
				createdDate: moment().format(DATE_TIME_FORMAT),
				updatedDate: moment().format(DATE_TIME_FORMAT),
				keepOriginalPO: 'Y',
				poNumber: item.poNumber,
				buyerLineNo: item.keepOriginalPO === 'Y' ? item.buyerLineNo : '',
				imagePath:item.imagePath,
				overpackQuantityRequired: item.overpackQuantityRequired,
				packageQuantity: item.packageQuantity,
				
	        };
			if(item.keepOriginalPrice) {
				tempItem = {
					...tempItem,
					keepOriginalPrice: item.keepOriginalPrice
				};
			}
			if(item.lineNo) {
				tempItem = {
					...tempItem,
					lineNumber: item.lineNo
				};
			}
			if(item.originalOrderNumber) {
				tempItem = {
					...tempItem,
					orderNumber: item.originalOrderNumber,
					orderLineId: item.orderLineId
				};
			}
			if(item.pricingDate) {
				tempItem = {
					...tempItem,
					orderDate: item.pricingDate
				};
			}
			if(item.parentItem){
				tempItem = {
					...tempItem,
					parentItem: item.parentItem,
				};
				
			}
			updatedItems.push(tempItem);
			item.relatedServices && item.relatedServices.forEach(itm => {
				if(itm.type !== 'BAG') {
					let relatedServiceItem = {
			            itemType: 'S',
			            item: itm.serviceId,
			            quantity: itm.quantity && itm.quantity !== '0' ? itm.quantity : 1,
			            itemDescription: itm.serviceName,
						agreementNumber: item.agreementNumber,
						parentItem: item.item,
						createdDate: moment().format(DATE_TIME_FORMAT),
						updatedDate: moment().format(DATE_TIME_FORMAT),
						keepOriginalPO: 'Y',
						poNumber: item.poNumber,
						imagePath:item.imagePath,
						overpackQuantityRequired: item.overpackQuantityRequired,
						packageQuantity: item.packageQuantity,
						unitPrice: itm.price,
						extendedPrice: parseFloat(itm.price * (itm.quantity || 1)),
			        }
					updatedItems.push(relatedServiceItem);
					cartItem.push(relatedServiceItem)
				}
			});
		});
		if (!formError) {
			this.setState((prevState) => ({
				...prevState, 
				cartItem : cartItem
			  }));

			let payload = {responseObject : {
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems: updatedItems
			}};
			self.props.saveToCart(payload);
		}
	}

	manageAvailableServices(finalData, sku, zipCode) {
		const self = this;
		const availableServices = _.find(finalData, {sku, zipCode});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true, null);
		})
	}

	callBackAfterAllCallCompleted() {
		const self = this;
		const {
			isCartGetOrgAttributesCompleted,
			isCartPimDataCallCompleted,
			isCartProductPriceCallCompleted,
			isCartServicePriceCallCompleted
		} = self.state;
		if(isCartGetOrgAttributesCompleted && isCartPimDataCallCompleted && isCartProductPriceCallCompleted && isCartServicePriceCallCompleted) {
			self.fireCartViewTag();
			self.setState({
				onlyAvailabilityCall: false
			});
		}
	}

	fireCartViewTag() {
		const self = this;
		if(self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems && self.props.state.cart.cart.responseObject.cartItems.length) {
			let totalCartCost = 0;
			const { backOrders, bulkOrdersHold } = self.props.state.order;
			//const { shippingAddressDetailsListWithZipCode } = this.props.state.user;
			const isPricingAccess = this.props.isResponsibilityExists("Price");
			self.props.state.cart.cart.responseObject.cartItems.forEach((item, index) => {
				let prices = item.itemType !== 'S' ? _.filter(self.props.state.cart.prices, { item_number: item.item }) : _.find(this.props.state.cart.services_prices, { itemNumber: item.item });
				let price = 0;
				if(isPricingAccess && prices) {
					if(item.itemType !== 'S') {
						prices = prices.filter(it => it.records && it.records[0] && this.compareSalesAgreements(it.records[0], item));
						prices = prices.length > 0 ? prices[0] : null;
						if(prices && prices.records && prices.records.length && this.compareSalesAgreements(prices.records[0], item) && (prices.records[0].adjusted_unit_price || prices.records[0].unit_price)) {
							price = prices.records[0].adjusted_unit_price || prices.records[0].unit_price;
						}
					} else {
						price = prices.unitPrice;
					}
				}
				// Check if item is added from back orders then need to set original order details price to show and pass it everywhere
				if(item.keepOriginalPrice === 'Y' && backOrders && backOrders.responseObject) {
					const backOrder = backOrders.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
					let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => itm.orderLineId === item.orderLineId && itm.item === item.item);
					// check once if item details not available then it may be added from bulk orders hold section
					if (!itemDetails) {
						const bulkOrderHold = bulkOrdersHold.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
						itemDetails = bulkOrderHold && bulkOrderHold.orderDetail && bulkOrderHold.orderDetail.orderLine.find(itm => itm.item === item.item);
					}
					// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
					if(itemDetails) {
						price = itemDetails.itemPrice.salesPrice;
					}
				}
				totalCartCost += price * (item.quantity || 1);
			});
			self.props.fireGTMTag('Cart View', {
				cartQuantity: self.props.state.cart.cart.responseObject.cartItems.length,
				cartValue: self.props.formatMoney(parseFloat(totalCartCost).toFixed(2), 0, ".", ",", false, "$")
			});
		}
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show' + dialog]: false
		}, () => {
			this.setState({
				['show' + dialog]: flag
			})
		})
	}

	showAddAccessories(sku, itemDescription, event) {
		event.preventDefault();
		this.setState({
			accessoriesSku: sku,
			itemDescription: itemDescription,
			showAddAccessories: false
		}, () => {
			this.setState({
				showAddAccessories: true
			})
		});
	}

	removeFromDialogCart(findRemovedItem){
		const self = this;
		findRemovedItem = findRemovedItem[0];
		let cartItemBackup = JSON.parse(JSON.stringify(this.state.cartItem));

		cartItemBackup.map(item => {
			if(item.itemType != "S" && item.relatedServices && item.relatedServices.length > 0 && findRemovedItem.parentItem == item.item){
				item.relatedServices = item.relatedServices.filter(rs => rs.serviceId !== findRemovedItem.item)
			}

			if(item.relatedServices && item.relatedServices.length == 0){
				delete item.relatedServices;
			}
			return null;
		})

		if(findRemovedItem.parentItem){
			cartItemBackup = cartItemBackup.filter((itm) => {
				return !(itm.parentItem &&
					 findRemovedItem.parentItem === itm.parentItem && 
					 findRemovedItem.item === itm.item);
			})
		}
		else{
			cartItemBackup = cartItemBackup.filter((itm) => {
				return findRemovedItem.item !== itm.item;
			})
		}
		

		this.setState((prevState) => ({
			...prevState, 
			cartItem : cartItemBackup
		  }));
	}

	handleProductSpec(item, index, price, availableQty, event) {
		event && event.preventDefault();
		const self = this;
        // Fire gtm tag of product click
        const data = self.props.getBrandCategory(item.item, 'cart');
        self.props.fireGTMTag('Product Click', {
			ecommerce: {
				currencyCode: 'USD',
				click: {
					actionField: {
						list: undefined,
					},
					products: [{
						name: item.itemDescription,
						id: item.item,
						price: self.props.formatMoney(price, 0, ".", ",", false, ""),
						brand: data.brand,
						category: data.category,
						variant: undefined,
						position: (index + 1).toString(),
						dimension70: availableQty === '0' ? 'yes' : 'no'
					}]
				}
			}
		});
		browserHistory.push("/product-specs/product-number/" + item.item);
	}

	handleRemoveAll(event) {
		event.preventDefault();
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		self.fireGTMTagForRemoveAllFromCart();
		self.props.state.cart.availability = [];
		self.props.state.cart.prices = [];
		self.props.state.cart.services_prices = [];
		let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems: []
		};
		if(self.props.isPunchOutAccess()){
			this.setState((prevState) => ({
				...prevState, 
				cartItem : []
			  }));
			self.props.saveToCart({responseObject :payload});
		}
		else{
			self.props.addToCart(payload, response => {
				if (response.status && response.responseObject) {
					self.props.saveToCart(response);
				} else {
					browserHistory.push('/error');
				}
			});
		}
	}

	fireGTMTagForRemoveAllFromCart() {
		const self = this;
		const cartItems = self.props.state.cart.cart.responseObject.cartItems;
		const products = [];
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const isPricingAccess = self.props.isResponsibilityExists("Price");
		const { availability } = self.props.state.cart;
		cartItems.forEach(item => {
			const availabilityData = availability && _.find(availability, { sku: item.item });
			let data = {
				availableQty: null,
				intransitQty: null,
				etaDate: null,
			};
			if(availabilityData) {
				data = {
					availableQty: availabilityData.availableQty,
					intransitQty: availabilityData.intransitQty,
					etaDate: availabilityData.etaDate,
				};
				if(self.validateFP(item, availabilityData)) {
					data.intransitQty = null;
					data.etaDate = 'FP';
				} else {
					data = self.validateFDD(item, availabilityData);
				}
			}
			let prices = item.itemType !== 'S' ? _.filter(self.props.state.cart.prices, { item_number: item.item }) : _.find(this.props.state.cart.services_prices, { itemNumber: item.item });
			let price = 0;
			if(isPricingAccess && prices) {
				if(item.itemType !== 'S') {
					prices = prices.filter(it => it.records && it.records[0] && this.compareSalesAgreements(it.records[0], item));
					prices = prices.length > 0 ? prices[0] : null;
					if(prices && prices.records && prices.records.length && this.compareSalesAgreements(prices.records[0], item) && (prices.records[0].adjusted_unit_price || prices.records[0].unit_price)) {
						price = prices.records[0].adjusted_unit_price || prices.records[0].unit_price;
					}
				} else {
					price = prices.unitPrice;
				}
			}
			// Check if item is added from back orders then need to set original order details price to show and pass it everywhere
			if(item.keepOriginalPrice === 'Y' && backOrders && backOrders.responseObject) {
				const backOrder = backOrders.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
				let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => itm.orderLineId === item.orderLineId && itm.item === item.item);
				// check once if item details not available then it may be added from bulk orders hold section
				if (!itemDetails) {
					const bulkOrderHold = bulkOrdersHold.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
					itemDetails = bulkOrderHold && bulkOrderHold.orderDetail && bulkOrderHold.orderDetail.orderLine.find(itm => itm.item === item.item);
				}
				// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
				if(itemDetails) {
					price = itemDetails.itemPrice.salesPrice;
				}
			}
			const brandData = self.props.getBrandCategory(item.item, 'cart');
			products.push({
				name: item.itemDescription,
				id: item.item,
				price: self.props.formatMoney(price, 0, ".", ",", false, ""),
				brand: brandData.brand,
				category: brandData.category,
				variant: undefined,
				quantity: item.quantity,
				dimension70: item.orderNumber ? 'no' : (item.quantity > data.availableQty ? 'yes' : 'no')
			});
		});
		// populate below undefined fields
		self.props.fireGTMTag('Remove from Cart', {
			ecommerce: {
				currencyCode: 'USD',
				remove: {
					products
				}
			}
		});
	}

	handleRemove(index, price, availableQty, event) {
		event.preventDefault();
		const self = this;
		const deletingItem = self.props.state.cart.cart.responseObject.cartItems[index];
		const data = self.props.getBrandCategory(deletingItem.item, 'cart');
		// populate below undefined fields
		self.props.fireGTMTag('Remove from Cart', {
			ecommerce: {
				currencyCode: 'USD',
				remove: {
					products: [{
						name: deletingItem.itemDescription,
						id: deletingItem.item,
						price: self.props.formatMoney(price, 0, ".", ",", false, ""),
						brand: data.brand,
						category: data.category,
						variant: undefined,
						quantity: deletingItem.quantity,
						dimension70: deletingItem.orderNumber ? 'no' : (deletingItem.quantity > availableQty ? 'yes' : 'no')
					}]
				}
			}
		});

		let findRemovedItem = this.props.state.cart.cart.responseObject.cartItems.filter((itm, ind) => {
			return ind == index;
		})
		const cartItems = this.props.state.cart.cart.responseObject.cartItems.filter((itm, ind) => {
			return ind !== index;
		})
		this.props.removeAvailabilityFromCart(findRemovedItem)
		if(self.props.isPunchOutAccess()){
			this.removeFromDialogCart(findRemovedItem);
		}
		this.props.state.cart.cart.responseObject.cartItems = cartItems;
		// this.props.state.cart.availability = _.uniq(_.pullAllBy(this.props.state.cart.availability, [{ 'sku': sku }], 'sku'));
		// this.props.state.cart.prices = _.uniq(_.pullAllBy(this.props.state.cart.prices, [{ 'sku': sku }], 'sku'));
		// this.props.state.cart.services_prices = _.uniq(_.pullAllBy(this.props.state.cart.services_prices, [{ 'sku': sku }], 'sku'));
		const { selectedAccount, userDetails } = self.props.state.user;
		let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems: this.props.state.cart.cart.responseObject.cartItems
		};
		
		if(self.props.isPunchOutAccess()){
			self.props.saveToCart({responseObject :payload});
		}
		else{
			this.props.addToCart(payload, response => {
				if (response.status && response.responseObject) {
				  self.props.saveToCart(response);
				  self.setState({
					onlyAvailabilityCall: true
					}, () => {
						self.checkAvailabilityAndAll();
					});
				} else {
					browserHistory.push('/error');
				}
			});
		}
		
  	}

	handleUpdateCartWithRemoveKeepOriginalPriceRemoval(index) {
		const self = this;
		const cartItems = self.props.state.cart.cart.responseObject.cartItems;
		delete cartItems[index].keepOriginalPrice;
		cartItems[index].orderDate = moment().tz('America/New_York').format('MM/DD/YYYY')
		const { selectedAccount, userDetails } = self.props.state.user;
		let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems
		};
		this.props.addToCart(payload, response => {
			if (response.status && response.responseObject) {
			  self.props.saveToCart(response);
			} else {
				browserHistory.push('/error');
			}
		});
  	}

	wasSecondPricingCallHappened(currentItem) {
		const self = this;
		let flag = false;
		const { changedSABackup } = self.state;
		changedSABackup.forEach(item => {
			if (item.item === currentItem.item && item.orderNumber === currentItem.orderNumber &&
				item.quantity === currentItem.quantity && currentItem.agreementNumber !== item.agreementNumber
			) {
				flag = true;
			}
		});
		return flag;
	}

	updateBackupWithItemAndIndex(currentItem) {
		const self = this;
		const { changedSABackup } = self.state;
		const { cartBackup = {} } = self.props.state.cart;
		const cartItems = cartBackup.responseObject ? cartBackup.responseObject.cartItems : [];
		const backupItem = cartItems.find(item => item.item === currentItem.item && item.orderNumber === currentItem.orderNumber &&
			item.quantity === currentItem.quantity);

		let alreadyAdded = false;
		changedSABackup.forEach(item => {
			if (item.item === currentItem.item && item.orderNumber === currentItem.orderNumber &&
				item.quantity === currentItem.quantity
			) {
				item = currentItem;
				item.agreementNumber = backupItem.agreementNumber;
				alreadyAdded = true;
			}
		});
		if (!alreadyAdded) {
			changedSABackup.push({
				...currentItem,
				agreementNumber: backupItem.agreementNumber
			});
		}
		self.setState({
			changedSABackup
		});
	}

	handlePriceSourceChange(item, index, event) {
		const self = this,
			{ userDetails, selectedAccount, selectedAccountsAllPriceSources } = self.props.state.user,
			{ cart } = self.props.state.cart,
			{ cartItems } = cart.responseObject,
			isPricingAccess = self.props.isResponsibilityExists("Price");

		cartItems[index].agreementNumber = event.target.value;
		delete cartItems[index].agreementNumberError;
		const payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems: cartItems
		};
		self.props.addToCart(payload, response => {
			if (response.status && response.responseObject) {
				self.props.saveToCart(response);
				if(isPricingAccess) {
					const items = [];
					if(cartItems[index].agreementNumber && (cartItems[index].itemType === 'M' || cartItems[index].itemType === 'A') && (cartItems[index].agreementNumber && selectedAccountsAllPriceSources.responseObject.find(it => it.AGREEMENT_NUMBER.toString() === cartItems[index].agreementNumber))) {
						items.push(cartItems[index].item);
					}
					if(items.length) {
						self.setState({
							currentIndex: index
						}, () => {
							let pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
							let canWeMakeAnotheCall = false;
							// if keepOriginalPrice is 'Y' then we need to pass that date else we need to pass today's date
							if (cartItems[index].keepOriginalPrice === 'Y') {
								pricingEffectiveDate = moment(cartItems[index].orderDate).format('YYYYMMDD');
								canWeMakeAnotheCall = true;
							}
							const pricingPayload = {
								account_number: selectedAccount.ACCOUNTNUMBER,
								pricing_effective_date: pricingEffectiveDate,
								sa_number: cartItems[index].agreementNumber,
								item_numbers: items
							};
							self.props.checkForPrices(pricingPayload, true, false, '', response => {
								response = processPricingResponse(response);
								// if we have to make second call as price is not available for original price then make call with today's date
								if (canWeMakeAnotheCall && !self.props.isPricingAvailable(response)) {
									pricingPayload.pricing_effective_date = moment().tz('America/New_York').format('YYYYMMDD');
									self.props.checkForPrices(pricingPayload, true, false, '', resp => {
										resp = processPricingResponse(resp);
										// if pricing available then update backup object for future reference.
										if (self.props.isPricingAvailable(resp)) {
											self.handleUpdateCartWithRemoveKeepOriginalPriceRemoval(index);
											self.updateBackupWithItemAndIndex(item);
										} else {
											self.updateBackupWithItemAndIndex(item);
										}
										self.setState({
											isPricingChanged: true
										});
										self.updatePrices(resp.responseObject && resp.responseObject.items);
										self.setState({
											onlyAvailabilityCall: true
										}, () => {
											self.checkAvailabilityAndAll();
										})
									});
								} else {
									self.setState({
										isPricingChanged: true
									});
									self.updatePrices(response.responseObject && response.responseObject.items);
									self.setState({
										onlyAvailabilityCall: true
									}, () => {
										self.checkAvailabilityAndAll();
									})
								}
							});
						});
					}
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}

	updatePrices(items = []) {
		const self = this,
			{ cart } = self.props.state.cart,
			{ cartItems } = cart.responseObject;
		let prices = [];
		if(self.props.state.cart && self.props.state.cart.prices) {
			prices = self.props.state.cart.prices.filter(itm => itm.item_number && itm.item_number !== cartItems[self.state.currentIndex].item);
		}
		prices = prices.concat(items);
		self.props.updatePricesToCart(prices);
	}

	onBlurQuantity(sku, cartItemIndex, price, availableQty, event) {
		const self = this;
		const cart  = JSON.parse(JSON.stringify(self.props.state.cart.cart));
		let cartItems = cart.responseObject.cartItems;
		const changingItem = cartItems[cartItemIndex];
		const { quantity: previousQuantity, cartItemIndex: previouslySavedIndex, sku: previouslySavedSku } = self.state.focusedCartItemDetails;
		const currentQuantity = changingItem.quantity;
		// If older and new quantity is different then only fire gtm tag of differences of older and new quantity
		if (previousQuantity !== currentQuantity && cartItemIndex === previouslySavedIndex && previouslySavedSku === sku) {
			const data = self.props.getBrandCategory(sku, 'cart');
			const quantity = currentQuantity - previousQuantity;
			const products = [{
				name: changingItem.itemDescription,
				id: sku,
				price: self.props.formatMoney(price, 0, ".", ",", false, ""),
				brand: data.brand,
				category: data.category,
				variant: undefined,
				quantity: Math.abs(quantity),
				dimension70: changingItem.orderNumber ? 'no' : (changingItem.quantity > availableQty ? 'yes' : 'no')
			}];
			if (quantity <= -1) {
				self.props.fireGTMTag('Remove from Cart', {
					ecommerce: {
						currencyCode: 'USD',
						remove: {
							products
						}
					}
				});
			} else {
				let cartCount = 0;
				cartItems.forEach((itm, index) => {
					cartCount += parseInt(itm.quantity, 10);
				});
				self.props.fireGTMTag('Add to Cart', {
					addToCartLocation: 'cart',
					cartQuantity: cartCount,
					ecommerce: {
						currencyCode: 'USD',
						add: {
							actionField: {
								list: undefined,
								position: undefined,
							},
							products
						}
					}
				});
			}
		}
	}

	onFocusQuantity(sku, cartItemIndex, quantity) {
		const self = this;
		self.setState({
			focusedCartItemDetails: {
				sku,
				cartItemIndex,
				quantity: !quantity ? 0 : quantity,
			}
		});
	}

	debouncedCartUpdateOnQuantityChange = _.debounce((cartPayload, isAvailabilityCheckRequired) => {
		this.props.addToCart(cartPayload, response => {
			if (response.status && response.responseObject) {
				if (isAvailabilityCheckRequired) {
					const zipCode = this.props.customZipCode;
					zipCode && this.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							this.checkOrderAvailability(resp);
						}
					})
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}, 300)

	handleQuantityChange(itemIndex, itemAvailabilityData, event) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		const cart  = JSON.parse(JSON.stringify(self.props.state.cart.cart));
		let cartItems = cart.responseObject.cartItems;
		let formError = false;
		const value = Math.max(1, event.target.value && event.target.value.trim());
		let isQuantityChanged = false;
		let isAvailabilityCheckRequired = false;
		cartItems.forEach((item, index) => {
			if(index === itemIndex) {
				if (item.quantity !== value) {
					isQuantityChanged = true;
					item.quantity = value;
					item.quantityError = '';
					if((item.itemType === 'M' || item.itemType === 'A') && (!itemAvailabilityData || item.quantity > itemAvailabilityData.availableQty)){
						isAvailabilityCheckRequired = true;
					}
				}
			} else if (!item.quantity) {
				formError = true;
				delete item.quantity;
			}
		});
		self.props.saveToCart(cart);
		const items = JSON.parse(JSON.stringify(cartItems));
		if (!formError && value !== null && value !== "" && isQuantityChanged) {
			let payload = {
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems: items
			};
			self.debouncedCartUpdateOnQuantityChange(payload, isAvailabilityCheckRequired);
		}
	}

	handleCreateOrder(somePricesNotAvailable, event) {
		event && event.preventDefault();
		const self = this;
		const { selectedAccountsAllPriceSources } = self.props.state.user;
		let formError = false;
		const cartItems = self.props.state.cart.cart;
		cartItems.responseObject && cartItems.responseObject.cartItems && cartItems.responseObject.cartItems.forEach(item => {
			if(!item.quantity) {
				formError = true;
				item.quantityError = 'error';
			}
			if(item.overpackQuantityRequired && (item.overpackQuantityRequired.toLowerCase() === "true" || item.overpackQuantityRequired.toLowerCase() === "1" || item.overpackQuantityRequired.toLowerCase()==="yes") && item.quantity == "1"){
				formError = true;
				item.quantityError = 'error';
			}
			if(!item.agreementNumber || !selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber)) {
				formError = true;
				item.agreementNumberError = 'error';
			}
		});
		if (somePricesNotAvailable) {
			formError = true;
		}
		if(formError) {
			self.props.saveToCart(cartItems);
			return;
		}
		self.props.checkIfAnyActiveSoldAddress(() => {
			// check and update from back up if it is already there in store
			const createOrderPayloadBackup = JSON.parse(JSON.stringify(self.props.state.order.createOrderPayloadBackup));
			let data = JSON.parse(self.props.state.user.selectedAddress);
			let zipCode = data ? data.POSTALCODE.split('-')[0] : '';
			let warehouseCode = '';
			let shipToState = self.props.getShipToState();
			let SITEID = data ? data.SITEID : '';
			let SITEUSEID = data ? data.SITE_USE_ID : '';
			if (createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params && createOrderPayloadBackup.createOrderForm.params.shippingAddress) {
				zipCode = createOrderPayloadBackup.createOrderForm.params.shippingAddress.zip.split('-')[0];
				warehouseCode = createOrderPayloadBackup.createOrderForm.params.warehouseCode;
				shipToState = createOrderPayloadBackup.createOrderForm.params.shippingAddress.state;
				SITEID = createOrderPayloadBackup.createOrderForm.params.shippingAddress.SITEID;
				SITEUSEID = createOrderPayloadBackup.createOrderForm.params.shippingAddress.addressId;
			}
			// Reset below flag to avoid receipve props's verify back order Method
			self.setState({
				callReveiveProps: false,
				// set it in store to further use at 2 places to avoid further checking and reading from store for backup of createorder
				zipCode,
				warehouseCode,
				shipToState,
				SITEID,
				SITEUSEID,
			}, () => {
				const cartItems = self.props.state.cart && self.props.state.cart.cart && self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems;
				if(cartItems && cartItems.find(itm => itm.orderNumber)) {
					self.setState({
						backOrderCallCompleted: false,
						bulkOrderHoldCallCompleted: false,
					}, () => {
						self.props.checkForBackOrders(self.props.getSelectedAccountNumber(), true, (response) => {
							self.setState({
								backOrderCallCompleted: true,
								backOrders: response.responseObject || []
							}, () => {
								self.callBackAfterCallsCompleted();
							});
						});
						self.props.checkForBulkOrdersHold(self.props.getSelectedAccountNumber(), true, (response) => {
							self.setState({
								bulkOrderHoldCallCompleted: true,
								bulkOrders: response.responseObject || []
							}, () => {
								self.callBackAfterCallsCompleted();
							});
						});
					});
				} else {
					self.handleContinueCreateOrder();
				}
			});
		});
	}

	transferCart(event){
		event && event.preventDefault();
		const self = this;
		let totalCartCost = 0;
		const cartItems = self.props.state.cart.cart;
		let cartItemName = (this.state.cartItem && this.state.cartItem.length > 0 ? this.state.cartItem : cartItems.responseObject.cartItems).map(itm => itm.item);
		self.props.getPIMItemInfo(cartItemName, "requestType=getPIMItemInfo", response => {
			if(response.status) {
				const  pimData  = response.responseObject;
				cartItems.responseObject && cartItems.responseObject.cartItems && cartItems.responseObject.cartItems.length > 0 && cartItems.responseObject.cartItems.forEach((item, index) => {
					let price = 0;
					if (item.itemType === 'M' || item.itemType === 'A') {
						price = _.filter(self.props.state.cart.prices, { item_number: item.item });
						price = price.find(it => it.records && it.records[0] && this.compareSalesAgreements(it.records[0], item));
					}
					if (price && price.records && price.records.length > 0)
						price = price.records[0].adjusted_unit_price || price.records[0].unit_price
					else {
						price = _.find(this.props.state.cart.services_prices, { itemNumber: item.item })
						if (price)
							price = price.unitPrice
					}
					totalCartCost += price * (item.quantity || 1);
					item.price = price;
					const pimItem = _.find(pimData, { item_number: item.item });
					if(pimItem){
						item.unspcClacification = pimItem.geego_unspc_classification;
					}
					return null
				});
				self.props.saveToCart(cartItems);
				self.props.transferCart(totalCartCost, this.state.date);
			}
		});
		
	}


	callBackAfterCallsCompleted() {
		const self = this;
		const { backOrderCallCompleted, bulkOrderHoldCallCompleted, backOrders, bulkOrders } = self.state;
		if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
			self.verifyBackOrders(backOrders.concat(bulkOrders), () => {
				self.handleContinueCreateOrder();
			});
		}
	}

	handleContinueCreateOrder() {
		const self = this;
		const { selectedAccount, selectedPriceSource } = self.props.state.user;
		const skuList = [],
			servicesSkuList = [],
			skuListForPim = [];
		let totalCartCost = 0;
		const cartItems = self.props.state.cart.cart;
		const { availability } = this.props.state.cart;
		const { cartPimData } = this.props.state.cart;
		const { pimData } = cartPimData;
		const orderNumbers = [];
		let data = JSON.parse(self.props.state.user.selectedAddress);
		cartItems.responseObject && cartItems.responseObject.cartItems && cartItems.responseObject.cartItems.length > 0 && cartItems.responseObject.cartItems.forEach((item, index) => {
			if ((item.itemType === 'M' || item.itemType === 'A') && !item.orderNumber) {
				const availabilityData = availability && _.find(availability, { sku: item.item });
				let finalProductionDate = null;
				const pimItemData = pimData && _.find(pimData, {item_number: item.item});
				if(pimItemData && pimItemData.geego_final_production_date && pimItemData.geego_final_production_date !== 'NULL') {
					finalProductionDate = moment(pimItemData.geego_final_production_date).format('MM/DD/YYYY');
				}
				skuList.push({
					itemNumber: item.item,
					identifier: index + 1,
					qty: item.quantity || 1,
					shipSet: availabilityData && self.validateFP(item, availabilityData) ? '' : 1,
					shipMethod: 'ADC Truckload',
					arrivalSetName: '',
					itemType: '',
					demandClass : self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
					overrideFlag: 'N',
					quantityUOM: 'EA',
					finalProductionDate,
					agreementNumber: item.agreementNumber,
					lifeCyclePhase : pimItemData && pimItemData.lifecycle_phase || pimItemData && pimItemData[0].lifecycle_phase,
				});
			} else {
				servicesSkuList.push({ sku: item.item })
			}
			if (item.orderNumber && !orderNumbers.includes(item.orderNumber)) {
				orderNumbers.push(item.orderNumber);
			}

			skuListForPim.push(item.item);

			let price = 0;
			if (item.itemType === 'M' || item.itemType === 'A') {
				price = _.filter(self.props.state.cart.prices, { item_number: item.item });
				price = price.find(it => it.records && it.records[0] && this.compareSalesAgreements(it.records[0], item));
			}
			if (price && price.records && price.records.length > 0)
				price = price.records[0].adjusted_unit_price || price.records[0].unit_price
			else {
				price = _.find(this.props.state.cart.services_prices, { itemNumber: item.item })
				if (price)
					price = price.unitPrice
			}
			totalCartCost += price * (item.quantity || 1);
			item.price = price;
			return null
		});

		if (orderNumbers.length) {
			self.props.getOrderDetailsInParallelBatches(orderNumbers, () => {
				self.setState({
					orderDetailsCallCompleted: true
				}, () => {
					self.callBackBeforeRedirectingToCreateOrder();
				});
			});
		} else {
			self.setState({
				orderDetailsCallCompleted: true,
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}

		self.props.saveToCart(cartItems);
		// make service call to get pim details
		let attributeName = "geego_top_load";
		self.props.getOrgAttributesByAttributeName("Top Load Indicator", (resp) => {
			if(!resp) {
				attributeName = "geego_no_top_load";
			}
			self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
				if (response.status) {
					const responseObject = response.responseObject ? response.responseObject : null;
					// update products in state with uncrateInd to use it later for priceOrder service
					let finalProducts = [];
					self.props.state.cart.cart.responseObject.cartItems.forEach(item => {
						if(!item.item) return null;
						let uncrateInd = "N";
						const pimItemData = _.find(responseObject, { item_number: item.item });
						if(pimItemData && pimItemData.geego_uncrateind) {
							let geego_uncrateind = pimItemData.geego_uncrateind;
							const { selectedAccountsAllPriceSources } = self.props.state.user;
							const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
							if(record) {
								uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
							}
						}
						finalProducts.push({
							...item,
							pointValue: pimItemData && pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.quantity) : 0.00,
							uncrateInd,
							lifeCyclePhase : pimItemData && pimItemData.lifecycle_phase || pimItemData && pimItemData[0].lifecycle_phase,
						});
					});
					self.setState({
					  isPimCallCompleted: true,
					  pimData: responseObject,
					  products: finalProducts,
					  noShippingZipCodeFound: '',
					}, () => {
						const accountNumber = selectedAccount.ACCOUNTNUMBER;
						if (self.props.getZipCode()) {
							self.props.getShippingAddressesDetails(self.props.getZipCode(), false, 'adc_loc', resp => {
								if (resp && resp.agentid) {
									// now make pricing service call
									const payload = {
										accountNumber: accountNumber,
										warehouseCode: resp.agentid,
										shipmentMethod: "ADC Truckload",
										shipToState:JSON.parse(self.props.state.user.selectedAddress).STATE || self.state.shipToState,
										orderTotal: totalCartCost,
										priceItems: [],
										priceDate: moment().format(messageConstants.DATE_FORMAT)
									};
									self.state.products.forEach(itm => {
										payload.priceItems.push({
											itemNumber: itm.item,
											qty: itm.quantity,
											agreementNumber: itm.agreementNumber,
											uncrateInd: itm.uncrateInd,
											grossPointValue: itm.pointValue ? itm.pointValue : 0,
										})
									});
									// make pricing service call
									self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
										if(!response.status || !response.responseObject) {
											self.props.addErrorLog({
												location: window.location.href,
												errorMessage: messageConstants.PRICE_ORDER_SERVICE_ERROR
											});
										}
										self.setState({
											isPricingCallCompleted: true,
											pricingData: response.responseObject
										}, () => {
											self.callBackBeforeRedirectingToCreateOrder();
										});
									});
								} else {
									self.setState({
										isPricingCallCompleted: true
									}, () => {
										self.callBackBeforeRedirectingToCreateOrder();
									});
								}
							});
						} else {
							self.setState({
								noShippingZipCodeFound: 'No shipping address found'
							});
						}
					});
				}
			})
		});

		if(selectedPriceSource.SHIPPING_METHOD) {
			self.props.getShippingMethod(`shippingMethodCode=${selectedPriceSource.SHIPPING_METHOD}`, response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					self.setState({
						isShippingMethodCompleted: true
					}, () => {
						self.callBackBeforeRedirectingToCreateOrder();
					})
				}
			});
		} else {
			self.setState({
				isShippingMethodCompleted: true
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			})
		}

		if(skuList.length > 0) {

			// To set the flag to flase when selectedADC is not present in redux state
			// if there is any backup available then we have to pass second param as false
			// we are picking warehouse code details from selected address in create order and edit order
			let flag = true;
			if (self.props.state.order.createOrderPayloadBackup && !(self.props.state.user && self.props.state.user.selectedADC) ) {
				flag = false;
			}
			self.props.getZipCode() && self.props.getShippingAddressesDetails(self.props.getZipCode(), flag, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					// new availability call
					const payload = {
						accountNumber: self.props.getSelectedAccountNumber(),
						warehouseCode:  resp.agentid ? resp.agentid : self.state.warehouseCode,
						customerSiteId: self.state.SITEUSEID,
						requestedDeliveryDate: moment().format('MM/DD/YYYY'),// As of now passing the current date as part of WCP-8097
						orderSource: '',
						zipCode: self.props.getZipCode(),
						state: data.STATE || "",
						country: data.COUNTRY,
						tradingPartnerId:'',
						dateType:'SHIP',
						items: skuList
					};
					self.props.checkAvailabilityForOrder(payload, response => {
						self.setState({
							isAvailabilityCallCompleted: true,
							availabilityData: response
						}, () => {
							self.callBackBeforeRedirectingToCreateOrder();
						});
					});
				} else {
					self.setState({
						isAvailabilityCallCompleted: true,
					}, () => {
						self.callBackBeforeRedirectingToCreateOrder();
					});
				}
			});
		} else {
			self.setState({
				isAvailabilityCallCompleted: true,
				availabilityData: [],
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}

		// Check duplicate PONumber and keep data in store, it can be used to show duplicate message if user select submit order on review order page
		self.setState({
			last30DaysOrders: [],
			isLast30DaysOrdersCompleted: true,
			last60DaysOrders: [],
			isLast60DaysOrdersCompleted: true
		}, () => {
			self.callBackBeforeRedirectingToCreateOrder();
		});

		self.props.getBillingReferences(`requestType=getBillingReferences&accountNumber=${self.props.getSelectedAccountNumber()}`, response => {
			// self.props.getBillingReferences(`requestType=getBillingReferences&accountNumber=3589106`, (response) => {
			let responseObj = response.responseObject;
			if(response.status && responseObj && responseObj.length > 0) {
				responseObj.forEach(item => {
					item.requiredFlag = item.required;
					delete item.required;
				});
			}
			self.setState({
				isBillingPreferencesCallCompleted: true
			}, () => {
				self.props.saveBillingReferences(response);
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}, false);

		if (self.props.state.order.isOrderCreatedWithNewAddress) {
			self.props.updateAddressList(() => {
				self.setState({
					isGetAddressCallCompleted: true
				}, () => {
					self.callBackBeforeRedirectingToCreateOrder();
				});
			});
		} else {
			self.setState({
				isGetAddressCallCompleted: true
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}
	}

	getIndexes(array, pickFromArray, value) {
		const indexes = [];
		array.forEach((itm, ind) => {
			if (itm === value)
			indexes.push(pickFromArray[ind]);
		});
		return indexes;
	}

	callBackBeforeRedirectingToCreateOrder() {
	    const self = this;
	    const {
			isPricingCallCompleted,
			isPimCallCompleted,
			isShippingMethodCompleted,
			pimData,
			pricingData,
			isLast30DaysOrdersCompleted,
			isLast60DaysOrdersCompleted,
			last30DaysOrders,
			last60DaysOrders,
			isBillingPreferencesCallCompleted,
			isGetAddressCallCompleted,
			isAvailabilityCallCompleted,
			availabilityData,
			orderDetailsCallCompleted,
		} = this.state;
		const { cart, availability: availabilityBkp } = this.props.state.cart,
			items = [];
	    if (orderDetailsCallCompleted && isAvailabilityCallCompleted && isShippingMethodCompleted && isPricingCallCompleted && isPimCallCompleted && isLast30DaysOrdersCompleted && isLast60DaysOrdersCompleted && isBillingPreferencesCallCompleted && isGetAddressCallCompleted) {
			self.props.saveBookedOrders(last30DaysOrders.concat(last60DaysOrders));
			const { createOrderPayloadBackup } = self.props.state.order;
			let poNumber = '';
			let backupItem = null;
			if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params.poNumber) {
				poNumber = createOrderPayloadBackup.createOrderForm.params.poNumber;
				backupItem = createOrderPayloadBackup.createOrderForm.params.items;
			}
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				}
				cart.responseObject.cartItems.forEach((item, index) => {
					let availability = availabilityData.find(itm => itm.itemNumber === item.item && itm.identifier === index + 1);
					if(!availability && availabilityBkp) {
						const data = availabilityBkp.find(itm => itm.sku === item.item);
						if(data) {
							availability = {
								requestedDateQuantity: data.availableQty,
								requestedDeliveryDate: '',
								groupShipDate: '',
								groupShipDateBkp: '',
								shipDate: '',
							};
						}
					}
					let salesPriceData = pricingData ? _.find(pricingData, itm => {
						return itm.itemPrice.item === item.item && itm.itemPrice.lineIndex === (index + 1).toString() && item.quantity.toString() === itm.itemPrice.qty.toString()
					}) : null;
					// check if this item is added from back orders or bulk order hold, then need to check order details pricing
					// Check if item is added from back orders then need to set original order details price to show and pass it everywhere
					if(item.keepOriginalPrice === 'Y' && !self.wasSecondPricingCallHappened(item)) {
						const { backOrders, bulkOrdersHold } = self.props.state.order;
						if(backOrders && backOrders.responseObject) {
							const backOrder = backOrders.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
							let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => itm.orderLineId === item.orderLineId && itm.item === item.item);
							// check once if item details not available then it may be added from bulk orders hold section
							if (!itemDetails) {
								const bulkOrderHold = bulkOrdersHold.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
								itemDetails = bulkOrderHold && bulkOrderHold.orderDetail && bulkOrderHold.orderDetail.orderLine.find(itm => itm.item === item.item);
							}
							// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
							if(itemDetails) {
								item.price = itemDetails.itemPrice.salesPrice;
								salesPriceData = {
									itemPrice: {
										salesPrice: item.price
									}
								}
							}
						}
					}
					// If its not available from priceOrder service response then use it from search result pricing service
					// Its already getting saved in .price of products object
					if(!salesPriceData && item.price) {
						salesPriceData = {
							itemPrice: {
								salesPrice: item.price
							}
						}
					}
			        const pimItemData = _.find(pimData, { item_number: item.item });
			        if (availability && salesPriceData && pimItemData) {
						const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
						const replacementSKUs = hasReplacement ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded") : [];
						const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1 ?true:false;
						const substituteSKUs = hasSubstitute ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute") : [];
						const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1 ?true:false;
						const upgradeSKUs = hasUpgrade ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell") : [];
						const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
						const lifeCyclePhase = pimItemData && pimItemData.lifecycle_phase || pimItemData && pimItemData[0].lifecycle_phase;
						const agreementNumber = item.agreementNumber;
					  	const product = _.find(self.state.products, {item: item.item});
						// check if any services are added in cart whose parentItem is current item
						const relatedServices = [];
						// initial uncrateind of item number
						let uncrateInd = product && product.uncrateInd;
						const alreadyAddedServices = cart.responseObject.cartItems.filter(itm => itm.itemType === 'S' && itm.parentItem === item.item);
						if(alreadyAddedServices.length > 0) {
							// prepare related services and append it along with prepare bag items
							alreadyAddedServices.forEach(itm => {
								const prices = _.find(self.props.state.cart.services_prices, { itemNumber: itm.item });
								if(prices && prices.unitPrice) {
									relatedServices.push({
										serviceId: itm.item,
										price: prices.unitPrice,
										serviceName: prices.description,
										quantity: itm.quantity,
										extendedPrice: parseFloat(prices.unitPrice * itm.quantity),
									});
									const servicePimData = _.find(pimData, { item_number: itm.item });
									// check if any service is having uncrated Y then it will be Y else as it is from item
									uncrateInd = servicePimData.geego_fg_uncrate_required ? 'Y' : uncrateInd;
								}
							});
						};
						let ifAnyPOInBackup = '';
						if (backupItem && backupItem[index] && backupItem[index].item === item.item && backupItem[index].quantity === item.quantity && backupItem[index].poNumber) {
							ifAnyPOInBackup = backupItem[index].poNumber;
						}
						let newItem = {
							packageName: item.packageName ? item.packageName.toUpperCase() : '',
							item: item.item,
							itemDescription: item.itemDescription,
							itemType: item.itemType,
							quantity: item.quantity,
							quantityError: '',
							imagePath:item.imagePath,
							overpackQuantityRequired : item.overpackQuantityRequired,
							packageQuantity: item.packageQuantity,
							price: salesPriceData.itemPrice.salesPrice,
							relatedServices: relatedServices.concat(self.props.prepareBagItems(salesPriceData)),
							// this can be used to calculate orderTotal without making pricing service call again before orderPrice service
							originalPrice: item.price,
							pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.quantity) : 0.00,
							perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
							geego_cust_acct: pimItemData.geego_cust_acct,
							lifeCyclePhase,
							// Top load indicator value for backup
							perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
							// No top load indicator value for backup
							perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
							brand: pimItemData['geego_brand'],
							category: pimItemData['item_catalog_group'],

							geego_final_production_date: pimItemData['geego_final_production_date'],
							geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
							geego_uncrateind: pimItemData.geego_uncrateind,

							weight: self.props.getOrderWeightFromPimData(pimItemData, item.quantity),
							perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
							agreementNumber,
							originalAgreementNumber: agreementNumber,
							hasReplacement,
							hasSubstitute,
							hasUpgrade,
							replacementSKUs,
							substituteSKUs,
							upgradeSKUs,
							isFedexable,
							uncrateInd,
							originalUncrateInd: product && product.uncrateInd,
							requestedDeliveryDate: 'delivery1',
							originalDelivery: 'delivery1',
							requestedDeliveryDateBackUp: 'delivery1',
							keepOriginalPrice: !self.wasSecondPricingCallHappened(item) ? item.keepOriginalPrice : undefined,
							buyerLineNo: item.keepOriginalPO === 'Y' ? item.buyerLineNo : '',
							pricingDate: item.orderDate ? self.props.formatDate(item.orderDate, 'MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
							keepOriginalPO: item.keepOriginalPO,
							poNumber: item.keepOriginalPO === 'Y' ? item.poNumber : (ifAnyPOInBackup || poNumber),
							originalOrderNumber: item.orderNumber,
							redirectFrom: 'cart',
						};
						// pass modifiers from order details data if ordernumber and line number exists
						if (item.orderNumber && item.orderLineId) {
							newItem = {
								...newItem,
								lineNo: item.orderLineNumber,
								orderLineId: item.orderLineId,
								modifiers: self.props.getDataFromParallelCall(item.orderLineId, item.orderNumber, 'modifiers'),
								originalItem: self.props.getDataFromParallelCall(item.orderLineId, item.orderNumber, 'originalItem'),
								attribute: self.props.getDataFromParallelCall(item.orderLineId, item.orderNumber, 'attribute')
							};
						}
						items.push(newItem);
			        }
		      	});
				if(items.length === 0) {
					self.setState({
						errorOccured: "Error occured while fetching pricing or pim data"
					})
				} else {
					const zipCode = self.props.getZipCode();
					zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
						if(resp && resp.agentid) {
							const products = [];
							items.forEach(item => {
								products.push({
									name: item.itemDescription,
									id: item.item,
									price: self.props.formatMoney(item.price, 0, ".", ",", false, ""),
									brand: item.brand,
									category: item.category,
									variant: undefined,
									quantity: item.quantity,
									dimension70: item.quantity > item.availability  ? 'true' : 'no',
									dimension79: 1,
									dimension80: item.uncrateInd === 'Y' ? 'uncrated' : 'crated',
									dimension82: undefined
								});
							});
							self.props.fireGTMTag('Checkout Step', {
								shippingMethod: resp.isThisADCLOC ? "ADC Truckload" : "SDS Delivery",
								ecommerce:{
									currencyCode: 'USD',
									checkout: {
										actionField: {
											step: '1'
										},
										products
									}
								}
							});
							// self.props.resetAvailabilityToCart();
							// self.props.resetServicesPricesToCart();
							// self.props.resetPricesToCart();
							self.props.saveCreateOrderPayload({ items: items });
							browserHistory.push("/order/createOrder");
						}
					});
				}
			});
	    }
	}

	validateFP(item, availabilityData) {
		const self = this;
		const { cartPimData } = self.props.state.cart;
		let finalProductionDate = null;
		const pimData = cartPimData && cartPimData.pimData;
		const pimItemData = pimData && _.find(pimData, {item_number: availabilityData.sku});
		if(pimItemData && pimItemData.geego_final_production_date && pimItemData.geego_final_production_date !== 'NULL') {
			finalProductionDate = pimItemData.geego_final_production_date;
		}
		return self.props.checkIfFP({
			finalProductionDate: finalProductionDate,
			availableQty: availabilityData.availableQty,
			etaDate: availabilityData.etaDate && moment(availabilityData.etaDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
			requestedQuantity: item.quantity
		});
	}

	validateFDD(item, availabilityData) {
		const self = this;
		const { cartPimData } = self.props.state.cart;
		let firstDistributionDate = null;
		const pimData = cartPimData && cartPimData.pimData;
		const pimItemData = pimData && _.find(pimData, {item_number: availabilityData.sku});
		if(pimItemData && pimItemData.geego_distribution_start_date && pimItemData.geego_distribution_start_date !== 'NULL') {
			firstDistributionDate = pimItemData.geego_distribution_start_date;
		}
		return self.props.validateFDD({
			firstDistributionDate,
			availableQty: availabilityData.availableQty,
			intransitQty: availabilityData.intransitQty,
			etaDate: availabilityData.etaDate && moment(availabilityData.etaDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
		});
	}

  	render() {
		const self = this;
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const { shippingAddressDetailsListWithZipCode } = this.props.state.user;
		const isPricingAccess = this.props.isResponsibilityExists("Price");
		const showCreateOrderButton  = this.props.isResponsibilityExists("Create New Order") && this.props.isResponsibilityExists("Price");
		let totalCartCost = 0, orderPoints = 0.00, orderWeight = 0;
		const isPunchOutAccess = this.props.isPunchOutAccess();
		let { cart, availability, cartPimData } = this.props.state.cart;
		if (cart && cart.responseObject && cart.responseObject.cartItems.length > 0 && cartPimData) {
			const { pimData, attributeName } = cartPimData;
			cart.responseObject.cartItems.forEach(item => {
				let points = 0.00;
				let weight = 0;
				const pimItemData = _.find(pimData, {item_number: item.item});
				if(pimItemData) {
					points = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (item.quantity || 1)) : 0.00;
					weight = this.props.getOrderWeightFromPimData(pimItemData, (item.quantity || 1));
				}
				orderPoints += points;
				orderWeight += weight;
			});
			orderPoints = parseFloat(orderPoints).toFixed(2);
			orderWeight = parseFloat(orderWeight).toFixed(2);
		}
		availability = _.sortBy(JSON.parse(JSON.stringify(availability)), ['sku']);

		const selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources;
		let pimData = null;
		if(cartPimData) {
			pimData = cartPimData.pimData;
		}
		let somePricesNotAvailable = false;
		const currentZipDetails = shippingAddressDetailsListWithZipCode.find(
			entry => entry.zipCode === this.props.customZipCode
		) || shippingAddressDetailsListWithZipCode[shippingAddressDetailsListWithZipCode.length - 1];
		const hasSdsLoc = !!(
			currentZipDetails &&
			currentZipDetails.details &&
			currentZipDetails.details.some(d => d.loctype === "sds_loc")
		);
		const availableSDSDates = (this.state.sdsDeliveryCalendar && this.state.sdsDeliveryCalendar.dates) || [];
		let isThereAnyModelIsRestrictedInSelectedAccount = false;
		const toolTipContent = `The ETA is when the REQUESTED QUANTITY will be available from the GE Appliances ADC for an order placed today.<br/><br/>
						<b>6+ mos:</b> Model is currently in production, but demand exceeds all planned supply. “6+ mos.” indicates that we cannot provide an exact ETA date. The system estimate for availability under these conditions is greater than 6 months from today.<br/><br/>
						<b>FP:</b> Model is past the final production date and there is no more supply being produced. “FP” indicates that the model cannot be supplied from the serving warehouse and cannot be ordered.`;

		const firstAvailableDate = availableSDSDates.filter(d => d.available).map(d => moment(d.date, 'MM/DD/YYYY')).sort((a, b) => a - b)[0] || null;				
    	return (
	      	<div>
				<div>
					<h1 className="pageTitle">Cart <span className="unbold">(Create Order)</span></h1>
				</div>
				{this.state.errorOccured && <p className="bold red">{this.state.errorOccured}</p>}
				{/* this.props.state.order.availabilityError && <p className="bold red">{this.props.state.order.availabilityError}</p> */}
				{this.state.noShippingZipCodeFound && <p className="bold red">{this.state.noShippingZipCodeFound}</p>}
	        	{this.state.showErrorMessage && this.props.state.cart && this.props.state.cart.cart && this.props.state.cart.cart.cartItems && this.props.state.cart.cart.cartItems.length <= 0 ? <p>{this.state.errorMessage}</p> : ''}
				<ChangeZipCode
					saveCustomADC={self.props.saveCustomADC}
					customADC={self.props.customADC}
					selectedAccount={self.props.state.user.selectedAccount}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					acceptNumbersOnly={this.props.acceptNumbersOnly}
					handleSelectZipCode={this.props.saveCustomZipCode}
					zipCode={this.props.customZipCode}
					typeOfAccount={self.props.getSelectedAccountType()}
					showInStockFilter={false}
					updateServicePricing = {self.updateServicePricing}
				/>
	        	{this.props.state.cart.cart && this.props.state.cart.cart.responseObject && this.props.state.cart.cart.responseObject.cartItems.length > 0 ?
					<form onSubmit={this.props.doNothing}>
						{this.props.state.cart && this.props.state.cart.cart && this.props.state.cart.cart.responseObject && this.props.state.cart.cart.responseObject.cartItems.length > 0 &&
		                	<div>
								{!isPunchOutAccess && <div className="createOrderForm">
									<div className="orderPoints">Order Points: {orderPoints} &nbsp; &nbsp; Order Weight: {orderWeight}</div>
									</div>}
								<table className="dataTable cartTable borderTable">
				                    <thead>
										<tr>
											<th className="actions">
												<a className="deleteAllLink" onClick={this.handleRemoveAll.bind(this)} href="#">Remove All</a>
											</th>
											<th className="photo">Product</th>
											<th className="productInfo">Product Info</th>
											<th className="subtable">
												<table>
													<thead>
														<tr>
															<th className="quote">Sales<br />Agreement</th>
															<th className="availability">{/*Avail.<br />ETA*/}</th>
															{isPricingAccess && <th className="price">{(this.props.getSelectedAccountType() === "CONTRACT" || this.props.getSelectedAccountType() === "PRO CHANNEL" || this.props.getSelectedAccountType() === "HQ") ? '' : 'Net'}<br />Price<br /><span className="unbold">(Each)</span></th>}
															{isPricingAccess && <th className="priceDate">Price<br />Date</th>}
															<th className="quantity">
																Quantity
															</th>
															{isPricingAccess && <th className="extendedPrice textCenter">
																Extended<br />Price
															</th>}
														</tr>
													</thead>
												</table>
											</th>
										</tr>
				                    </thead>
									<tbody>
										{(this.state.cartItem && this.state.cartItem.length > 0 ? this.state.cartItem : this.props.state.cart.cart.responseObject.cartItems).map((item, index) => {
											const availabilityData = availability && _.find(availability, { sku: item.item });
											let prices = item.itemType !== 'S' ? _.filter(this.props.state.cart.prices, { item_number: item.item }) : _.find(this.props.state.cart.services_prices, { itemNumber: item.item });
											let price = 0;
											let isPriceAvailable = false;
											if(isPricingAccess && prices) {
												if(item.itemType !== 'S') {
													prices = prices.filter(it => it.records && it.records[0] && this.compareSalesAgreements(it.records[0], item));
													prices = prices.length > 0 ? prices[0] : null;
													if(prices && prices.records && prices.records.length && this.compareSalesAgreements(prices.records[0], item) && (prices.records[0].adjusted_unit_price || prices.records[0].unit_price)) {
														price = prices.records[0].adjusted_unit_price || prices.records[0].unit_price;
														isPriceAvailable = true;
													}
												} else {
													price = prices.unitPrice;
													isPriceAvailable = true;
												}
											}
											// Check if item is added from back orders then need to set original order details price to show and pass it everywhere
											if(item.keepOriginalPrice === 'Y' && !self.wasSecondPricingCallHappened(item) && ((backOrders && backOrders.responseObject) || (bulkOrdersHold && bulkOrdersHold.responseObject))) {
												const backOrder = backOrders && backOrders.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
												let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => itm.orderLineId === item.orderLineId && itm.item === item.item);
												// check once if item details not available then it may be added from bulk orders hold section
												if (!itemDetails) {
													const bulkOrderHold = bulkOrdersHold && bulkOrdersHold.responseObject.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
													itemDetails = bulkOrderHold && bulkOrderHold.orderDetail && bulkOrderHold.orderDetail.orderLine.find(itm => itm.item === item.item);
												}
												// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
												if(itemDetails) {
													price = itemDetails.itemPrice.salesPrice;
													isPriceAvailable = true;
												}
											}
											totalCartCost += price * (item.quantity || 1);
											let data = {
												availableQty: 0,
												intransitQty: 0,
												etaDate: '',
												shipDate: '',
											};
											if(availabilityData) {
												data = {
													availableQty: availabilityData.availableQty,
													intransitQty: availabilityData.intransitQty,
													etaDate: availabilityData.etaDate,
												};
												if(self.validateFP(item, availabilityData)) {
						 							data.intransitQty = null;
						 							data.etaDate = 'FP';
						 						} else {
						 							data = self.validateFDD(item, availabilityData);
						 						}
												if (item.quantity && data.availableQty >= item.quantity) {
													data.etaDate = moment().format('MM/DD/YYYY');
												}
											}
											const pimItemData = pimData && _.find(pimData, {item_number: item.item});
											let optionOverPackValues = [];
											if(item.overpackQuantityRequired && (item.overpackQuantityRequired === "1" || item.overpackQuantityRequired.toLowerCase() === "true" || item.overpackQuantityRequired.toLowerCase() === "yes") ){
												if(pimItemData && pimItemData.geego_overpack_quantity > 1){
													optionOverPackValues[0]= "select";
													for(let i=1 ; i<=20 ; i++){
														optionOverPackValues[i] = (pimItemData.geego_overpack_quantity * (i));
													}
												}
											}
											let firstDistributionDate = null;
											let lifeCyclePhaseValue = pimItemData && pimItemData.lifecycle_phase || pimItemData && pimItemData[0].lifecycle_phase;
											if(pimItemData && pimItemData.geego_distribution_start_date && pimItemData.geego_distribution_start_date !== 'NULL') {
												firstDistributionDate = pimItemData.geego_distribution_start_date;
											}
											if (!isPriceAvailable) {
												somePricesNotAvailable = true;
											}
											const isCurrentModelIsRestrictedInSelectedAccount = self.props.isAnyModelIsRestrictedInSelectedAccount(pimItemData);
											if (isCurrentModelIsRestrictedInSelectedAccount) {
												isThereAnyModelIsRestrictedInSelectedAccount = true;
											}
											const itemAvailabilityError = availabilityData && availabilityData.message &&
												this.props.state.order.itemAvailabilityFailedMsgList.some(itemAvailabilityFailedMsg => availabilityData.message.toLowerCase().includes(itemAvailabilityFailedMsg.toLowerCase())) && `This item cannot be ordered from ${availabilityData.warehouseCode}`;
											return <tr key={index} style={{verticalAlign: 'top'}}>
												<td className="actions">
													<div className="addToListLinkParagraph">
														<AddToList checkAvailabilityGeneric={this.props.checkAvailabilityGeneric} fireGTMTag={this.props.fireGTMTag} item={item.item} itemDescription={item.itemDescription} itemType={item.itemType} getZipCode={this.props.getZipCode}  getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
													</div>
													<p>
														<a className="removeProductLink" href="" onClick={this.handleRemove.bind(this, index, price, data && data.availableQty)}>✗ <u>Remove</u></a>{/* NOTE: U+2717 HEAVY BALLOT X */}
													</p>
												</td>
												<td className="photo">
												{item.itemType !== "S" && <a onClick={this.handleProductSpec.bind(this, item, index, price, data && data.availableQty)} href=""> <img src={item.imagePath} width={96} height={100} alt={item.itemDescription} title={item.itemDescription} /></a>}
												</td>
												<td className="productInfo">
													<div className="skuDiv">
														{item.itemType === "S"
															?<span>{item.item}</span>
															:<a onClick={this.handleProductSpec.bind(this, item, index, price, data && data.availableQty)} href="">{item.item}</a>
														}
													</div>
													<div className="productNameDiv">{item.itemDescription}</div>
													{item.itemType === 'M' && <p className="addAccessories">
													<a className="blueButton" href="" onClick={this.showAddAccessories.bind(this, item.item, item.itemDescription)} >+&nbsp;Accessories</a>
													</p>}

													{self.state.punchoutOrerableServies && self.state.punchoutOrerableServies.isShowInstallServiceForPunchout && item.itemType !== 'S' && item.itemType !== 'A' && <p className="addServices">
														<a className="blueButton" href="" onClick={this.showInstallService.bind(this, item.item,index)} >+&nbsp;Install services</a>
													</p>}
												</td>
												<td className="subtable">
													<table>
														<tbody>
															<tr style={{verticalAlign: 'top'}}>
																<td className="quote">
																	{selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject &&
																		<select disabled={isPunchOutAccess} className={item.agreementNumberError + ' prodQuote'} value={item.agreementNumber} id={"prodQuote"+index} onChange={this.handlePriceSourceChange.bind(this, item, index)} name="prodQuote" style={{ width: '90%' }}>
																			<option value="" key={0}>-- Select --</option>
																			{selectedAccountsAllPriceSources.responseObject.filter((itm)=>{
																				return itm.PRICE_LIST_NAME != "APPLIANCES - BLEM LOAD PRICE LIST" && itm.AGREEMENT_TYPE !== 'GEA Parts' && itm.AGREEMENT_TYPE != "GEA FS Standard Agreement"
																				}).map((item, index) => {
																				return <option value={item.AGREEMENT_NUMBER} key={(index + 1)}>{item.DISPLAY_AGREEMENT_NAME}</option>
																			})}
																		</select>
																	}
																</td>
																{item.itemType !== "S"
																	?<td className={`availability ${item.orderNumber ? 'green-text' : ''}`}>
																		{item.orderNumber && item.item
																			?self.props.getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel(item.orderNumber, item.item)
																			:null
																		}
																	</td>
																	:<td className="availability"></td>
																}
																{isPricingAccess
																	?<td className="price">
																		{price ? this.props.formatMoney(price, 0, ".", ",", false, "$") : null}
																	</td>
																	:null
																}
																{isPricingAccess && <td className="priceDate">
																	{(item.orderDate && this.props.formatDate(item.orderDate, 'MM/DD/YY')) || moment().format('MM/DD/YY')}
																</td>}
																{optionOverPackValues.length > 0?<td className="quantity">
																<select className={item.quantityError}
																	onChange={this.handleQuantityChange.bind(this, index, availabilityData)}
																	onFocus={this.onFocusQuantity.bind(this, item.item, index, item.quantity)}
																	onBlur={this.onBlurQuantity.bind(this, item.item, index, price, data && data.availableQty)}
																	value={item.quantity}>
																		{optionOverPackValues.map((val, index)=>{
																			return <option
																			name={"quantity_" + index} 
																			key={index} value={val}
																			>{val}</option>
																		}) }
																	</select>
																</td>:<td className="quantity">
																	<input
																		className={item.quantityError}
																		onKeyPress={this.props.acceptNumbersOnly.bind(this)}
																		type="text" disabled={item.orderNumber ? true : false}
																		name={"quantity_" + index}
																		value={item.quantity}
																		onPaste={this.props.doNothing}
																		onFocus={this.onFocusQuantity.bind(this, item.item, index, item.quantity)}
																		onBlur={this.onBlurQuantity.bind(this, item.item, index, price, data && data.availableQty)}
																		onChange={this.handleQuantityChange.bind(this, index, availabilityData)}
																		size={4}
																	/>
																</td>}
																{isPricingAccess
																	?<td className="extendedPrice textRight">
																		{price ? this.props.formatMoney(parseFloat(price * (item.quantity || 1)).toFixed(2), 0, ".", ",", false, "$") : null}
																	</td>
																	:null
																}
															</tr>
															{item.itemType !== "S" && !item.orderNumber &&
																<tr>
																	<td colSpan={ 3 } className="productStatusTablePositioningContainer">
																		<table className="productStatusTable" style={{float: 'right', marginRight: '155px', width: '60%'}}>
																			<thead>
																				<tr>
																					<th className="text-center" style={{width: '30%'}}>Available Now</th>
																					<th>ETA at ADC<a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ToolTipOverlayDialog", true)}>
																						<img src="../../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
																					<th className="text-center" style={{width: '30%'}}>Avail on ETA</th>
																				</tr>
																			</thead>
																			<tbody>
																				{lifeCyclePhaseValue === "Near End of Life" ? (<tr style={{verticalAlign: 'top'}}>
																				<td></td>
																				<td className="text-center" style={{width: '30%'}}>NLA</td>
																				<td></td>
																				</tr>):
																				(<tr style={{verticalAlign: 'top'}}>
																					<td style={{textAlign:"center"}}>
																						{data && data.availableQty < item.quantity
																							?<span className="red mt-0 mb-0" style={{fontWeight: 'bold'}}>
																								{data && data.availableQty}<br/>
																							</span>
																							:<span>{data && data.availableQty}<br/></span>
																						}
																					</td>
																					<td className={data.availableQty < item.quantity ? 'bold red' : undefined}>
																						{lifeCyclePhaseValue !== "Near End of Life" ? (data.etaDate && (moment(data.etaDate).isValid() ? moment(data.etaDate).format("MM/DD/YYYY") : data.etaDate)) : ""}
																					</td>
																					<td style={{textAlign:"center"}}>
																						{data && data.availableQty < item.quantity && moment(data.etaDate).isValid()
																							&& <span>
																									{(() => {
																											if(data.intransitQty === "10000000000"){
																												if(item.quantity){
																													return item.quantity
																												}else{
																													return "1"
																												}
																											}else{
																												return data && data.intransitQty
																											}
																									})()}
																							</span>
																						}
																					</td>
																				</tr>)}
																			</tbody>
																		</table>
																	</td>
																</tr>
															}
														</tbody>
													</table>
													{itemAvailabilityError && <p className="red">{itemAvailabilityError}</p>}
													{item.itemType !== "S" && availability && !availabilityData && <p className="red">This item is no longer available.</p>}
													{isPricingAccess && isPriceAvailable === false && !isPunchOutAccess &&
														<p className="red">This item is not priced. Please select different sales agreement.</p>
													}
													{isPricingAccess && isPriceAvailable === false && isPunchOutAccess &&
														<p className="red">This item is not available in this area.</p>
													}
													{isCurrentModelIsRestrictedInSelectedAccount &&
														<p className="red">Please remove the highlighted model. GEA is not currently selling this model to this account.</p>
													}
												</td>
											</tr>
										})}
									</tbody>
								</table>
								{isPricingAccess && <table className="subtotalTable cartSubtotalTable">
									<tbody>
										<tr>
											<td style={{ textAlign: "right" }}>Subtotal:</td>
											<td className="price" style={{ textAlign: "center" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {this.props.formatMoney(parseFloat(totalCartCost).toFixed(2), 0, ".", ",", false, "$")}</td>
										</tr>
									</tbody>
								</table>}
								<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", marginTop: "20px"}}>
								
								<div style={{ flex: "0 0 60%", textAlign: "left" }}>
									{isPunchOutAccess && (
											//this.state.
											hasSdsLoc ?<div style={{display:"flex"}}>
														<div >
															<div style={{fontWeight:"bold", fontSize:"16px"}}>SDS Delivery</div>
															<div style={{fontWeight:"bold", fontSize:"14px"}}>Requested Delivery Date</div>
															<p style={{fontStyle:"italic"}}>Offered dates assume prompt order <br />
																placement and are subject to change based <br />on agent capacity.<br />
															</p>
														</div>
														<div style={{display: "flex"}}>
															<DatePicker id="requestedDeliveryDate"	placeholderText="Click to select a date"
																filterDate={ date => availableSDSDates.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY')) } 
																onChange={this.handleChange} selected={this.state.date}  
																onChangeRaw={(e) => e.preventDefault()}
																openToDate={this.state.date || firstAvailableDate}
															/>									
														</div>
													</div>: 
													<div>
														<div style={{fontWeight:"bold", fontSize:"16px"}}>SDS Delivery</div>
														<div style={{color:"red"}}>{`Not available in this zip code`}</div>
													</div>
									)}
								 </div>
								<div className="textRight">
									{!isPunchOutAccess && showCreateOrderButton && !self.props.isSelectedAccountNumberAsIs && !isThereAnyModelIsRestrictedInSelectedAccount && <a className="greenButton" href="" onClick={this.handleCreateOrder.bind(this, somePricesNotAvailable)}>Create Order ►</a> }
									{ isPunchOutAccess && <a className="orangeButton" href="" onClick={this.transferCart.bind(this)}>Transfer cart</a> }
								</div>
								</div>
							
								<div className="clear" />
		                	</div>
						}
	            	</form>
	            	: <p>There are currently no products in your Cart.</p>
	        	}
		        {this.state.showWeAreSorryDialog
		            ? <GenericOverlayDialog flag={'WeAreSorryDialog'} extraParagraph={this.state.extraParagraph} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />
		            : null
		        }
		        {this.state.showAddAccessories
		            ? <AddAccessoriesDialog
						checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
						accessoriesSku={this.state.accessoriesSku}
						itemDescription={this.state.itemDescription}
						handleDialog={this.handleDialog.bind(this)}
						showDialog={true}
						getZipCode={this.props.getZipCode}
						getLocalStorageVar={this.props.getLocalStorageVar}
						manipulateProductSpecsData={this.props.manipulateProductSpecsData}
						isPricingAccess={this.props.isResponsibilityExists("Price")}
						fireGTMTag={this.props.fireGTMTag}
						formatMoney={this.props.formatMoney}
						getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
						checkAvailabilityForOrder={this.props.checkAvailabilityForOrder}
						formatOrderAvailabilityData={this.props.formatOrderAvailabilityData}
					/>
		            : null
		        }
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}

				{this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						isPunchOutAccess ={isPunchOutAccess}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog.bind(this)}
						itemLevelDisableUncrateDropdown={this.state.itemLevelDisableUncrateDropdown}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.state.cartItem}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
						requiredPayloadForServicePricing={this.state.requiredPayloadForServicePricing}
					/>
				:null }
				{this.state.showToolTipOverlayDialog?<ToolTipOverlayDialog title="ETA" content={toolTipContent} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
	      	</div>
    	);
	}
}

const mapStateToProps = (state) => {
  return { state };
};

const mapDispatchToProps = (dispatch) => ({
	addToList: (payload, callback) => dispatch(addToList(payload, callback)),
	saveToList: (payload) => dispatch(saveToList(payload)),
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
	saveToCart: (payload) => dispatch(saveToCart(payload)),
	saveCreateOrderPayload: (payload) => dispatch(saveCreateOrderPayload(payload)),
	saveCreateOrderPayloadBackup: (data) => dispatch(saveCreateOrderPayloadBackup(data)),
	checkServicesPricesForCartPage: (payload, params, response) => dispatch(checkServicesPricesForCartPage(payload, params, response)),
	getPriceOrder: (payload, params, response) => dispatch(getPriceOrder(payload, params, response)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	getOrderList: (queryStringParams, callback, errorRedirection) => dispatch(getOrderList(queryStringParams, callback, errorRedirection)),
	saveBookedOrders: (data) => dispatch(saveBookedOrders(data)),
	getBillingReferences: (queryString, callback, errorRedirection) => dispatch(getBillingReferences(queryString, callback, errorRedirection)),
	getShippingMethod: (queryString, callback) => dispatch(getShippingMethod(queryString, callback)),
	saveBillingReferences: (data) => dispatch(saveBillingReferences(data)),
	updatePricesToCart: (data) => dispatch(updatePricesToCart(data)),
	resetAvailabilityToCart: () => dispatch(resetAvailabilityToCart()),
	resetErrorLog: () => dispatch(resetErrorLog()),
	resetServicesPricesToCart: () => dispatch(resetServicesPricesToCart()),
	resetPricesToCart: () => dispatch(resetPricesToCart()),
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
	getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
	saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
	checkForPrices: (payload, showLoader, saveToStore, cartOrOrder, response) => dispatch(checkForPrices(payload, showLoader, saveToStore, cartOrOrder, response)),
	saveAvailabilityToCart: data => dispatch(saveAvailabilityToCart(data)),
	removeAvailabilityFromCart: data => dispatch(removeAvailabilityFromCart(data)),
	getDeliveryCalendar: (payload, queryString, showLoader, callback) => dispatch(getDeliveryCalendar(payload, queryString, showLoader, callback)),
});

Cart = connect(mapStateToProps, mapDispatchToProps)(Cart);
export default Cart;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Cart/index.js